// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pane_ajaBp {
  transition: box-shadow 0.2s;
}
.pane_ajaBp.pane-overlay_vxudj {
  padding: var( --size-padLarge );
  background-color: var( --color-white );
}
.pane_ajaBp.pane-overlay_vxudj:hover {
  box-shadow: none;
}
.pane_ajaBp.pane-navHeader_wiqfL {
  border: none;
  height: 50px;
  box-shadow: 0 8px 16px var( --color-shadowBase ),0 0px 1px var( --color-shadowBase );
  transition: width 0.4s;
  background-color: var( --color-brand900 );
}
.pane_ajaBp.pane-loginPane_kl1fh {
  border: 1px solid var( --color-base100 );
  padding: var( --size-padXLarge );
  box-shadow: 0 8px 16px var( --color-shadowBase ),0 0px 1px var( --color-shadowBase );
  border-radius: 8px;
  background-color: var( --color-white );
}
.pane_ajaBp.pane-contentSection_MJg2_ {
  padding: var( --size-padLarge );
  background-color: transparent;
  border-top-width: 0px;
  border-left-width: 0px;
  border-right-width: 0px;
  border-bottom-width: 0px;
}
.pane_ajaBp.pane-contentSection_MJg2_.pane-contentBorder_e5jpf {
  padding: var( --size-padLarge ) var( --size-padLarge ) 24px;
  border-bottom: 1px solid var( --color-base200 );
}
.pane_ajaBp.pane-formHeader_VXjDE {
  padding: var( --size-padLarge );
  border-left: none;
  border-right: none;
  border-bottom: 2px solid var( --color-base100 );
  background-color: var( --color-white );
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}
.pane_ajaBp.pane-formBody_o6CCf {
  padding: var( --size-padLarge );
  border-top: 1px solid var( --color-base050 );
  border-left: none;
  border-right: none;
  border-bottom: none;
  background-color: var( --color-base025 );
}
.pane_ajaBp.pane-formHeader_VXjDE.pane-formButtons_i_qgk {
  padding: var( --size-padLarge );
  border-top: 1px solid var( --color-base100 );
  border-bottom-width: 0px;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
}
.pane_ajaBp.pane-dialogHeader_kCcQX {
  padding: var( --size-padLarge );
}
.pane_ajaBp.pane-dialogBody_oizj4 {
  width: auto;
  max-width: 50000px;
  padding-left: var( --size-padMedium );
  padding-right: var( --size-padMedium );
  background-color: var( --color-base050 );
}
.pane_ajaBp.pane-dialogFooter_tP60i {
  padding: var( --size-padLarge );
}
.pane_ajaBp.pane-dialog_FXK8m {
  z-index: 1;
  box-shadow: 0 8px 16px var( --color-shadowBase ),0 0px 1px var( --color-shadowBase );
  max-height: 80vh;
  border-radius: 8px;
  background-color: var( --color-white );
}
.pane_ajaBp.pane-loginWarning_zCQxl {
  border: 1px solid var( --color-danger100 );
  padding: var( --size-padMedium );
  margin-top: 16px;
  min-height: 0px;
  border-radius: 4px;
  margin-bottom: 0px;
  background-color: var( --color-shadowDanger );
}
.pane_ajaBp.pane-formGeoshape_pnmYI {
  padding: var( --size-padLarge );
  border-radius: 4px;
  background-color: var( --color-white );
}
.pane_ajaBp.pane-contentSection_MJg2_.pane-contentSectionWhite_djC5_ {
  padding: 56px;
  background-color: var( --color-white );
}
.pane_ajaBp.pane-card_kwSo4 {
  width: 100%;
  padding: var( --size-padLarge );
  box-shadow: 0 1px 3px var( --color-shadowBase );
  border-radius: var( --size-medium );
  background-color: var( --color-white );
}
.pane_ajaBp.pane-mobileTabPortal_DwbOX {
  height: 100%;
  background-color: var( --color-white );
}
.pane_ajaBp.pane-mobileActions_k1Y4_ {
  padding: var( --size-padXLarge ) var( --size-padLarge );
  background-color: var( --color-white );
  border-top-left-radius: var( --size-padLarge );
  border-top-right-radius: var( --size-padLarge );
}
.pane_ajaBp.pane-mobileTabsHeader_rYSYY {
  padding: var( --size-padLarge );
}
.pane_ajaBp.pane-mobileList_PBdHb {
  height: 100%;
  background-color: var( --color-base050 );
}
.pane_ajaBp.pane-mobileMapToggle_pGDYP {
  margin-left: var( --size-padMedium );
  padding-left: 12px;
  margin-right: var( --size-padMedium );
  padding-right: 40px;
}
.pane_ajaBp.pane-mobileItemHeader_svJKE {
  padding: var( --size-padLarge );
  z-index: 1;
  box-shadow: 0 1px 3px var( --color-shadowBase );
  background-color: var( --color-base050 );
}
.pane_ajaBp.pane-mobileItemBody_ePfFL {
  padding: var( --size-padLarge );
  background-color: var( --color-white );
}
.pane_ajaBp.pane-mobileList_PBdHb.pane-mobileListSettings_RbkVN {
  width: 100%;
  height: 100%;
  background-color: var( --color-base050 );
}
.pane_ajaBp.pane-mobileTabsHeader_rYSYY.pane-mobileDtrHeader_oFmAy {
  box-shadow: 0 1px 3px var( --color-shadowBase );
}
.pane_ajaBp.pane-mobileDtrContent_ZPAWi {
  padding: var( --size-padLarge );
}
.pane_ajaBp.pane-sidebar_Ipg9R {
  height: 100%;
  padding: var( --size-padLarge );
  box-shadow: 0 1px 3px var( --color-shadowBase );
}
.pane_ajaBp.pane-tablePagination_eESLq {
  height: 64px;
  box-shadow: 0 1px 3px var( --color-shadowBase );
  padding-left: var( --size-padMedium );
  padding-right: var( --size-padMedium );
  background-color: var( --color-white );
}
.pane_ajaBp.pane-editPageSizeOverlay_y0Xjn {
  width: 100vw;
  padding: var( --size-padLarge );
  max-width: 412px;
}
.pane_ajaBp.pane-rootHeader_bTPov {
  padding: var( --size-padMedium ) var( --size-padLarge ) var( --size-pad12 );
  z-index: 2;
  box-shadow: 0 1px 3px var( --color-shadowBase );
  min-height: 64px;
}
.pane_ajaBp.pane-dataCard_kDUPJ {
  padding: var( --size-padLarge );
}
.pane_ajaBp.pane-card_kwSo4.pane-graphContainer_Df06r {
  padding-left: 0px;
  padding-right: 0px;
}
.pane_ajaBp.pane-detail_ougWm.pane-detailCard_iw3Dk {
  box-shadow: 0 4px 8px rgba( 0, 0, 0, 0.2 );
  background-color: var( --color-white );
  border-top-width: 1px;
  border-top-color: var( --color-base100 );
  border-left-width: 1px;
  border-left-color: var( --color-base100 );
  border-right-width: 1px;
  border-right-color: var( --color-base100 );
  border-bottom-width: 1px;
  border-bottom-color: var( --color-base100 );
}
.pane_ajaBp.pane-dialogHeader_kCcQX.pane-detailHeader_jBddk {
  padding-top: var( --size-padMedium );
  padding-bottom: var( --size-padMedium );
}
.pane_ajaBp.pane-detailContent_bfmP9 {
  background-color: var( --color-white );
}
.pane_ajaBp.pane-collectionEditorListSection_g6tci {
  margin: 0px;
  border-right: 1px solid var( --color-base100 );
  background-color: var( --color-white );
}
.pane_ajaBp.pane-collectionEditorListHeader_ApPnI {
  padding: var( --size-padMedium ) var( --size-padLarge );
}
.pane_ajaBp.pane-collectionEditorSelectionSection_hSxhF {
  padding: 0px;
  background-color: var( --color-white );
}
.pane_ajaBp.pane-collectionEditorSelectionHeader_gciiA {
  padding: var( --size-padMedium );
  border-bottom: 1px solid var( --color-base200 );
  background-color: var( --color-base050 );
}
.pane_ajaBp.pane-collectionEditorSelectionContent_vMfBN {
  background-color: var( --color-white );
}
.pane_ajaBp.pane-dialogContent_B4P8x {
  max-height: 80vh;
}
.pane_ajaBp.pane-rootEditorContent_MeX7r {
  border-bottom: 2px solid var( --color-base200 );
}
.pane_ajaBp.pane-editorDialog_g0A_m {
  border-radius: var( --size-small );
  background-color: var( --color-white );
}
.pane_ajaBp.pane-editor_NYR8U {
  width: 100%;
  padding: var( --size-padMedium );
  min-width: 400px;
  background-color: var( --color-white );
}
.pane_ajaBp.pane-formFooter_ReEgG {
  border-top: none;
  background-color: var( --color-white );
}
.pane_ajaBp.pane-screenTitle_UjlsA {
  padding: var( --size-padLarge );
  min-height: 72px;
  border-bottom: 1px solid var( --color-base200 );
}
.pane_ajaBp.pane-topNav_UyBl5 {
  height: 56px;
  padding-right: 8px;
}
.pane_ajaBp.pane-tableFilter_J9wCJ {
  height: 100%;
  padding: var( --size-padLarge ) var( --size-padLarge ) 0px;
}
.pane_ajaBp.pane-sideNav_sHA6W {
  height: 100%;
  box-shadow: 1px 0px 3px var( --color-shadowBase );
}
.pane_ajaBp.pane-screenContent_OWAVf {
  padding: var( --size-padLarge );
  background-color: var( --color-base025 );
}
.pane_ajaBp.pane-actionBar_bHuF_ {
  background-color: transparent;
}
.pane_ajaBp.pane-aggregation_qF9Ed {
  border-bottom: 1px solid var( --color-base100 );
}
.pane_ajaBp.pane-dialogTitle_zwz3L {
  padding: var( --size-padMedium ) var( --size-padLarge );
  border-bottom: 2px solid var( --color-base100 );
}
.pane_ajaBp.pane-rootEditorHeader_aC1yN {
  z-index: 1;
}
.pane_ajaBp.pane-rootEditorFooter_Ob_UK {
  z-index: 1;
}
.pane_ajaBp.pane-detail_ougWm.pane-listDetail_vXDgW {
  box-shadow: none;
  border-radius: 0px;
}
.pane_ajaBp.pane-loginBackground_ykJDB {
  background: url("https://storage.googleapis.com/molten-ui-assets/login_background.jpeg") center center / cover no-repeat, #080613;
}
.pane_ajaBp.pane-mobileDetail_jqByO {
  border-bottom: 1px solid var( --color-base100 );
}
.pane_ajaBp.pane-cowList_k9GVx {
  box-shadow: none;
  border-bottom: 1px solid var( --color-base200 );
}
.pane_ajaBp.pane-navSecondaryMobile_RKhI1 {
  padding: var( --size-padLarge );
  background-color: transparent;
}
.pane_ajaBp.pane-mapActionBar_H5gvl {
  padding: var( --size-padSmall );
  box-shadow: 0 1px 3px var( --color-shadowBase );
  border-radius: var( --size-small );
  background-color: var( --color-white );
}
.pane_ajaBp.pane-mobileMainNav_jc23E {
  width: 80vw;
  height: 100%;
  background-color: var( --color-white );
}
.pane_ajaBp.pane-mobileNavRoutes_xZS9c {
  width: 100%;
}
.pane_ajaBp.pane-mobileNavUser_Y_8bj {
  padding: var( --size-padLarge );
}
.pane_ajaBp.pane-dashboardCardEditor_Y4lV0 {
  border: 1px dashed var( --color-base400 );
  padding: var( --size-padMedium );
  border-radius: 4px;
}
.pane_ajaBp.pane-dashboardCardEditorHeader_hefe2 {
  padding: var( --size-pad12 ) var( --size-padLarge );
  background-color: var( --color-white );
}
.pane_ajaBp.pane-dashboardCardEditorArea_NmL2F {
  background-color: var( --color-white );
}
.pane_ajaBp.pane-itemDashboard_JVy71 {
  background-color: var( --color-base050 );
}
.pane_ajaBp.pane-dashboardPlaceholderCard_z8X4d {
  border: 1px dashed var( --color-base400 );
  min-height: 100px;
  border-radius: 4px;
  background-color: var( --color-base100 );
}
.pane_ajaBp.pane-dashboardPlaceholderCard_z8X4d.pane-dashboardPlaceholderCardHighlight_vADXh {
  background-color: var( --color-brand050 );
  border-top-color: var( --color-brand300 );
  border-left-color: var( --color-brand300 );
  border-right-color: var( --color-brand300 );
  border-bottom-color: var( --color-brand300 );
}
.pane_ajaBp.pane-dashboardNoData_UtquX {
  padding: 100px var( --size-padXLarge );
  border-radius: 8px;
  background-color: var( --color-base100 );
}
.pane_ajaBp.pane-dashboardCardEditorHeader_hefe2.pane-dashboardCardHeader_odOyI {
  padding-top: var( --size-padMedium );
}
.pane_ajaBp.pane-dashboardCardEditor_Y4lV0.pane-dashboardCard_fgmtj {
  border: 1px solid var( --color-base200 );
  padding: 0px;
  border-radius: var( --size-medium );
  background-color: var( --color-white );
}
.pane_ajaBp.pane-dashboardCardEditor_Y4lV0.pane-dashboardCard_fgmtj.pane-dashboardTransparentCard_Tz_8p {
  background-color: var( --color-brand100 );
}
.pane_ajaBp.pane-dashboardCardEditor_Y4lV0.pane-dashboardTransparentCardEditor_saeRB {
  background-color: var( --color-brand100 );
}
.pane_ajaBp.pane-dashboardCardEditor_Y4lV0.pane-dashboardCard_fgmtj.pane-dashboardGridCard_e0CX4 {
  border: none;
  background-color: transparent;
}
.pane_ajaBp.pane-dashboardCardEditor_Y4lV0.pane-dashboardCardEditorTarget_X8C1T {
  background-color: var( --color-brand100 );
  border-top-color: var( --color-brand500 );
  border-left-color: var( --color-brand500 );
  border-right-color: var( --color-brand500 );
  border-bottom-color: var( --color-brand500 );
}
.pane_ajaBp.pane-suggestions_vuvdK {
  width: 448px;
  box-shadow: none;
  border-top-width: 0px;
  border-left-width: 0px;
  border-right-width: 0px;
  border-bottom-width: 0px;
}
.pane_ajaBp.pane-itemForm_xYDdb {
  border-radius: 4px;
  background-color: var( --color-white );
}
.pane_ajaBp.pane-mobileItemForm_uFWiu {
  width: 100%;
  height: 100%;
  background-color: var( --color-white );
}
.pane_ajaBp.pane-formBody_o6CCf.pane-mobileItemFormBody_qKEhT {
  width: 100%;
  height: 100%;
  max-height: 100%;
}
.pane_ajaBp.pane-formHeader_VXjDE.pane-mobileItemFormHeader_Zq3BZ {
  padding: 0px;
}
.pane_ajaBp.pane-navSecondaryMobileContainer_zUyew {
  margin-top: 20%;
  padding-top: 2px;
  padding-bottom: 2px;
  background-color: var( --color-white );
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
}
.pane_ajaBp.pane-mobileSearchHeader_LDhfH {
  padding: 0px var( --size-padLarge ) var( --size-padLarge );
  border-bottom: 1px solid var( --color-base100 );
}
.pane_ajaBp.pane-mobileMainHeader_t7B97 {
  padding: 4px;
  box-shadow: 0 1px 3px var( --color-shadowBase );
}
.pane_ajaBp.pane-dashboardGridCardEditorArea_YxdY9 {
  padding: var( --size-padMedium );
  background-color: var( --color-base100 );
}
.pane_ajaBp.pane-itemDashboardContent_BTx1G {
  padding: var( --size-padLarge );
  background-color: transparent;
}
.pane_ajaBp.pane-aggregationItem_qsQwB {
  margin: 0px;
  padding: var( --size-padMedium );
  min-width: 100px;
  text-align: left;
  border-top: 0px solid var( --color-base200 );
  min-height: 80px;
  border-left: 0px solid var( --color-base200 );
  border-right: 1px solid var( --color-base200 );
  border-bottom: 0px solid var( --color-base200 );
}
.pane_ajaBp.pane-mobileSimpleSearchArea_oTWvE {
  box-shadow: inset 0 1px 3px var( --color-shadowBase );
  padding-top: var( --size-padLarge );
}
.pane_ajaBp.pane-navBar_pLjVF {
  padding-left: 12px;
  border-bottom: 1px solid var( --color-base200 );
  padding-right: 12px;
  background-color: var( --color-base025 );
}
.pane_ajaBp.pane-attributeTableInlineEditor_Ru9Mv {
  border: 1px solid transparent;
  min-height: 32px;
  border-radius: 4px;
}
.pane_ajaBp.pane-attributeTableInlineEditor_Ru9Mv:focus {
  border-top-color: var( --color-base700 );
  border-left-color: var( --color-base700 );
  border-right-color: var( --color-base700 );
  border-bottom-color: var( --color-base700 );
}
.pane_ajaBp.pane-navBarDivider_WXBux {
  margin-left: var( --size-padMedium );
  background-color: var( --color-base200 );
}
.pane_ajaBp.pane-sideNavBarDivider_hno4o {
  height: 1px;
  margin-top: 8px;
  margin-bottom: 8px;
  background-color: var( --color-base100 );
}
.pane_ajaBp.pane-dashboardGridCardEditorHeader_g20TJ {
  padding: var( --size-padLarge );
  background-color: var( --color-base100 );
}
.pane_ajaBp.pane-linearViewHeaderCell1_nEmiJ {
  border-right: 1px solid var( --color-brand200 );
  border-bottom: 1px solid var( --color-base100 );
  background-color: var( --color-base025 );
}
.pane_ajaBp.pane-linearViewHeaderCell2_KF29_ {
  text-align: center;
  border-right: 1px solid var( --color-base200 );
  background-color: var( --color-base100 );
}
.pane_ajaBp.pane-linearViewBlock_rg8fJ {
  border: 1px solid var( --color-brand300 );
  background-color: var( --color-brand100 );
}
.pane_ajaBp.pane-linearViewBlock_rg8fJ:hover {
  background-color: var( --color-brand200 );
}
.pane_ajaBp.pane-dialog_FXK8m.pane-linearViewBlockTooltip_PeZKY {
  padding: var( --size-padMedium );
  background-color: var( --color-white );
}
.pane_ajaBp.pane-linearViewRow_h4g9T {
  border-bottom: 1px solid var( --color-base100 );
}
.pane_ajaBp.pane-pairContent_hdFEw {
  background-color: var( --color-white );
}
.pane_ajaBp.pane-imageDetailValue_nLeEF {
  width: 100px;
  height: 100px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) center center / cover;
}
.pane_ajaBp.pane-dashboardTransparentCardArea_Ztgwn {
  background-color: transparent;
}
.pane_ajaBp.pane-dashboardGridCardArea_cdrpz {
  background-color: transparent;
}
.pane_ajaBp.pane-dialogTitle_zwz3L.pane-twoStepDialogTitle_dPqQ6 {
  border-bottom-width: 0px;
}
.pane_ajaBp.pane-formBody_o6CCf.pane-twoStepContent_woEUd {
  width: auto;
  max-width: 432px;
  background-color: var( --color-white );
}
.pane_ajaBp.pane-twoStepMethodsCard__pAld {
  border: 1px solid var( --color-base100 );
  padding: var( --size-padXLarge ) var( --size-padLarge );
  border-radius: 8px;
  background-color: var( --color-white );
}
.pane_ajaBp.pane-screenContent_OWAVf.pane-securityScreenContent_X6sd6 {
  background-color: var( --color-base025 );
}
.pane_ajaBp.pane-formBody_o6CCf.pane-twoStepContent_woEUd.pane-twoStepMobileContent_b9_xN {
  width: 100%;
}
.pane_ajaBp.pane-dialog_FXK8m.pane-twoStep_ja_dF.pane-twoStepMobile_LxQhw {
  min-height: 100%;
}
.pane_ajaBp.pane-rememberMeInfo_qJpKQ {
  width: 257px;
  padding: var( --size-padMedium );
}
.pane_ajaBp.pane-loginPane_kl1fh.pane-expiredActivationToken_f0rgQ {
  width: 100%;
  max-width: 360px;
  padding-top: 24px;
  padding-bottom: 24px;
}
.pane_ajaBp.pane-radio_yVdFs {
  border: 1px solid var( --color-base100 );
  padding: var( --size-padLarge );
  border-radius: var( --size-padMedium );
  background-color: var( --color-white );
}
.pane_ajaBp.pane-xyChartEditor_NUOoL {
  height: 100%;
  padding: var( --size-padLarge );
  min-height: 600px;
  margin-left: 0px;
  margin-right: 0px;
  background-color: var( --color-base050 );
}
.pane_ajaBp.pane-dashboardTransparentCardHeader_J6JEl {
  padding: 0px;
  border-top-color: transparent;
  border-left-color: transparent;
  border-right-color: transparent;
  border-bottom-color: transparent;
}
.pane_ajaBp.pane-mobileOptBarDivider_kFW1X {
  width: 100vw;
  border: 1px solid var( --color-base100 );
  transform: translate( -16px, 0 );
  margin-top: 8px;
  margin-right: -50%;
  margin-bottom: 16px;
}
.pane_ajaBp.pane-mobileOptNavTitle_zi4Xu {
  height: 48px;
  padding: 8px 16px;
  border-bottom: 1px solid var( --color-base100 );
}
.pane_ajaBp.pane-mobileOptNav_c_VEZ {
  max-height: 90%;
  padding-top: 2px;
  padding-bottom: 2px;
  background-color: var( --color-white );
  border-top-left-radius: var( --size-medium );
  border-top-right-radius: var( --size-medium );
}
.pane_ajaBp.pane-mobileNavTitle_B5b15 {
  border-bottom: 1px solid var( --color-base100 );
}
.pane_ajaBp.pane-navSecondaryMobileTitle_R5yEq {
  height: 48px;
  border-bottom: 1px solid var( --color-base100 );
}
.pane_ajaBp.pane-mobileTopNavBarDivider_xA6Pk {
  margin: 16px -16px;
  border-bottom: 1px solid var( --color-base100 );
}
.pane_ajaBp.pane-mobileFooterNav_aHEEN {
  width: 100%;
  border-top: 1px solid var( --color-base100 );
  margin-top: auto;
  padding-top: 4px;
  padding-bottom: 4px;
  background-color: var( --color-white );
}
.pane_ajaBp.pane-sortToggleBackground__iubB {
  padding: var( --size-padSmall );
  border-radius: var( --size-borderRadiusSmall );
  background-color: #f3f5f6;
}
.pane_ajaBp.pane-maintenanceEvent_Hh1qc {
  width: 100%;
  border: 2px solid var( --color-brand200 );
  padding: var( --size-padLarge );
  margin-top: var( --size-padMedium );
  border-radius: 4px;
  margin-bottom: var( --size-padMedium );
  background-color: var( --color-white );
}
.pane_ajaBp.pane-maintenanceEvent_Hh1qc.pane-maintenanceEventDegradation_ADBII {
  border-top-color: var( --color-warning500 );
  border-left-color: var( --color-warning500 );
  border-right-color: var( --color-warning500 );
  border-bottom-color: var( --color-warning500 );
}
.pane_ajaBp.pane-maintenanceEvent_Hh1qc.pane-maintenanceEventDowntime_Kn2JJ {
  border-top-color: var( --color-danger500 );
  border-left-color: var( --color-danger500 );
  border-right-color: var( --color-danger500 );
  border-bottom-color: var( --color-danger500 );
}
.pane_ajaBp.pane-infoCard_JoYpf {
  border: 1px solid var( --color-base100 );
  padding: var( --size-padMedium );
  border-radius: var( --size-padSmall );
  background-color: var( --color-brand025 );
}
.pane_ajaBp.pane-privacyNoticeContent_EEnta {
  max-height: 461px;
}
.pane_ajaBp.pane-dialog_FXK8m.pane-copyHoursWidget_IJHpX {
  min-width: 240px;
}
.pane_ajaBp.pane-dialogBody_oizj4.pane-largeDialogBody_IGANm {
  width: 80vw;
  height: 80vh;
}
.pane_ajaBp.pane-formSearchBar_mKDaN {
  padding: var( --size-padLarge );
  border-bottom: 1px solid var( --color-base200 );
  background-color: var( --color-base050 );
}
.pane_ajaBp.pane-formBreakdownItem_HFjVk {
  border: 1px solid var( --color-base200 );
  padding: var( --size-padMedium );
  border-radius: var( --size-small );
  background-color: var( --color-base025 );
}
.pane_ajaBp.pane-operatingHoursEditor_jLOdu {
  padding: var( --size-padLarge );
  background-color: var( --color-base025 );
}
.pane_ajaBp.pane-operatingHoursEditorContent_hpbCu {
  border: 1px solid var( --color-base200 );
  border-radius: 8px;
  background-color: var( --color-white );
}
.pane_ajaBp.pane-operatingHoursWeeklyGrid_IC3xk {
  border: 1px solid var( --color-base200 );
  border-radius: var( --size-padMedium );
}
.pane_ajaBp.pane-copyHoursWidgetHeader__pbDz {
  padding: var( --size-padLarge );
  border-bottom: 1px solid var( --color-base200 );
}
.pane_ajaBp.pane-copyHoursWidgetHeader__pbDz.pane-copyHoursWidgetFooter_a3chO {
  border-bottom: none;
}
.pane_ajaBp.pane-detail_ougWm {
  box-shadow: 0 8px 16px var( --color-shadowBase ),0 0px 1px var( --color-shadowBase );
  border-radius: 8px;
  background-color: var( --color-white );
}
.pane_ajaBp.pane-theftRecoveryCardContent_TzwzV {
  padding: var( --size-padLarge );
}
.pane_ajaBp.pane-dialogBody_oizj4.pane-dialogFormBody_x_94K {
  background-color: var( --color-base050 );
}
.pane_ajaBp.pane-conditionEditor_juEFj {
  border: 0px solid var( --color-base100 );
  padding: 16px;
  max-height: auto;
  border-radius: 2px;
  background-color: transparent;
}
.pane_ajaBp.pane-preConditionBar_bMCUz {
  width: 30px;
  height: 30px;
  margin-top: 4px;
  margin-right: 4px;
  border-radius: 2px;
}
.pane_ajaBp.pane-preConditionBar_bMCUz:hover {
  background-color: var( --color-brand050 );
}
.pane_ajaBp.pane-conditionBar_o1Ro0 {
  margin-top: 4px;
  margin-left: 4px;
}
.pane_ajaBp.pane-simpleFilterEditor_GdbyR {
  padding: 8px 16px 16px;
  border-radius: 4px;
  background-color: var( --color-base025 );
}
.pane_ajaBp.pane-simpleFilterEditorWrapper_jXdTG {
  width: auto;
  margin: 0px 1px 0px 0px;
  padding: 8px;
  min-width: 0px;
  max-width: 320px;
  border-top: 1px solid var( --color-base100 );
}
.pane_ajaBp.pane-pill_h_Rtd {
  font: normal 13px/20px Inter;
  color: #495a6e;
  border: 1px solid var( --color-base100 );
  padding: var( --size-padSmall ) var( --size-padLarge );
  margin-left: 0px;
  margin-right: var( --size-padMedium );
  border-radius: 100px;
  background-color: var( --color-white );
}
.pane_ajaBp.pane-sortFilterBarHorizontalDivider_fxOvS {
  height: 32px;
  margin-top: 4px;
  border-right: 1px solid var( --color-base200 );
  margin-bottom: 4px;
}
.pane_ajaBp.pane-conditionsList_5QeH1 {
  border: 2px dotted var( --color-base400 );
  padding: 4px;
  text-align: left;
  border-radius: 4px;
  background-color: var( --color-base025 );
}
.pane_ajaBp.pane-conditionFilterEditor_sXZan {
  padding: 0px;
}
.pane_ajaBp.pane-dashboardGridCardEditor_PNPYx {
  border: 1px solid var( --color-base400 );
  border-radius: 4px;
}
.pane_ajaBp.pane-dialogContent_B4P8x.pane-questionBody_jF8kU {
  padding: var( --size-padMedium );
  background-color: var( --color-white );
}
.pane_ajaBp.pane-dashboardGridCardEditorAreaTarget_u4Q1F {
  background-color: var( --color-warning500 );
}
.pane_ajaBp.pane-dashboardPlaceholderCardTarget_hmYUV {
  background-color: var( --color-brand200 );
}
.pane_ajaBp.pane-userEditorContent_OlpZk {
  padding: var( --size-padLarge );
}
.pane_ajaBp.pane-userEditorHeader_sB40n {
  padding: var( --size-padMedium );
}
.pane_ajaBp.pane-dialogBodyAlt_V7c6g {
  width: 496px;
  padding: 16px;
  background-color: var( --color-white );
}
.pane_ajaBp.pane-conditionRow_nxVi4 {
  padding: 8px 4px;
  min-width: 480px;
  transition: background-color var( --time-fast ) linear;
  border-radius: 2px;
}
.pane_ajaBp.pane-conditionRow_nxVi4:hover {
  border-radius: 8px;
}
.pane_ajaBp.pane-conditionRowEmpty_H8T7A {
  height: 64px;
  text-align: center;
  padding-top: var( --size-padXLarge );
  padding-bottom: var( --size-padXLarge );
}
.pane_ajaBp.pane-conditionRowEmpty_H8T7A:hover {
  background: transparent;
}
.pane_ajaBp.pane-sortEditor_mYlAT {
  padding: var( --size-padMedium ) var( --size-padLarge ) var( --size-padLarge );
}
.pane_ajaBp.pane-mobileNavBar_jtJ0y {
  width: 100%;
  padding: 16px;
}
.pane_ajaBp.pane-disclaimerContainer_EGcv9 {
  padding: 8px 16px;
  border-radius: 2px;
  background-color: var( --color-base100 );
}
.pane_ajaBp.pane-noDataContent_VRfa6 {
  max-width: 400px;
}
.pane_ajaBp.pane-bulkCreateMapFieldsEntry_recKx {
  padding-top: var( --size-padXLarge );
}
.pane_ajaBp.pane-ruleSetHeader_f7afX {
  padding: 0px var( --size-padLarge ) var( --size-padLarge );
  border-bottom: 1px solid var( --color-base100 );
  border-top-width: 1px;
  border-top-color: var( --color-base100 );
  border-left-width: 1px;
  border-left-color: var( --color-base100 );
  border-right-width: 1px;
  border-right-color: var( --color-base100 );
}
.pane_ajaBp.pane-conditionEditor_juEFj.pane-logicConditionEditor_Fm0h_ {
  padding: var( --size-padMedium );
  border-top-width: 0px;
  border-top-color: var( --color-base200 );
  border-left-width: 0px;
  border-left-color: var( --color-base200 );
  border-right-width: 0px;
  border-right-color: var( --color-base200 );
  border-bottom-width: 0px;
  border-bottom-color: var( --color-base200 );
}
.pane_ajaBp.pane-ruleItem_b6H05 {
  border: 1px solid var( --color-base100 );
  padding: var( --size-padMedium );
  min-width: 300px;
  border-radius: var( --size-padMedium );
}
.pane_ajaBp.pane-ruleItem_b6H05.pane-ruleBlock_DyThC {
  background-color: #e9eefc;
  border-top-style: solid;
  border-top-color: #1646c5;
  border-left-style: solid;
  border-left-color: #1646c5;
  border-right-style: solid;
  border-right-color: #1646c5;
  border-bottom-style: solid;
  border-bottom-color: #1646c5;
}
.pane_ajaBp.pane-ruleItem_b6H05.pane-ruleBlock_DyThC.pane-ruleBlockSelected_UbRnq {
  border: 2px dashed #1646c5;
  box-shadow: 0 3px 4px rgba( 0, 0, 0, 0.2 );
  background-color: #a4b7ef;
}
.pane_ajaBp.pane-ruleItem_b6H05.pane-logicRuleBlock_ZgwHc {
  background-color: #f9fafb;
  border-top-width: 1px;
  border-top-color: #67798e;
  border-left-width: 1px;
  border-left-color: #67798e;
  border-right-width: 1px;
  border-right-color: #67798e;
  border-bottom-width: 1px;
  border-bottom-color: #67798e;
}
.pane_ajaBp.pane-ruleItem_b6H05.pane-ruleBlock_DyThC.pane-ruleBlockSelected_UbRnq.pane-logicRuleBlockSelected_B8wHy {
  background-color: #d0dae6;
  border-top-color: #67798e;
  border-left-color: #67798e;
  border-right-color: #67798e;
  border-bottom-color: #67798e;
}
.pane_ajaBp.pane-ruleItem_b6H05.pane-modifyRuleBlock_VDIfL {
  background-color: #fdf8f4;
  border-top-width: 1px;
  border-top-color: #c76e48;
  border-left-width: 1px;
  border-left-color: #c76e48;
  border-right-width: 1px;
  border-right-color: #c76e48;
  border-bottom-width: 1px;
  border-bottom-color: #c76e48;
}
.pane_ajaBp.pane-ruleItem_b6H05.pane-ruleBlock_DyThC.pane-ruleBlockSelected_UbRnq.pane-modifyRuleBlockSelected_j0NVA {
  border: 2px dashed #c76e48;
  box-shadow: 0 2px 4px rgba(183, 183, 183, 0.75);
  background-color: #ffddd1;
}
.pane_ajaBp.pane-ruleItem_b6H05.pane-sendRuleBlock_rpkSa {
  background-color: #f4f9f7;
  border-top-width: 1px;
  border-top-color: #23a78d;
  border-left-width: 1px;
  border-left-color: #23a78d;
  border-right-width: 1px;
  border-right-color: #23a78d;
  border-bottom-width: 1px;
  border-bottom-color: #23a78d;
}
.pane_ajaBp.pane-ruleItem_b6H05.pane-ruleBlock_DyThC.pane-ruleBlockSelected_UbRnq.pane-sendRuleBlockSelected_V0qHd {
  background-color: #afe2c7;
  border-top-color: #23a78d;
  border-left-color: #23a78d;
  border-right-color: #23a78d;
  border-bottom-color: #23a78d;
}
.pane_ajaBp.pane-ruleItem_b6H05.pane-sendRuleBlock_rpkSa.pane-eventRuleBlock_haVLg {
  background-color: #f4f9f7;
  border-top-width: 1px;
  border-top-color: #23a78d;
  border-left-width: 1px;
  border-left-color: #23a78d;
  border-right-width: 1px;
  border-right-color: #23a78d;
  border-bottom-width: 1px;
  border-bottom-color: #23a78d;
}
.pane_ajaBp.pane-ruleItem_b6H05.pane-ruleBlock_DyThC.pane-ruleBlockSelected_UbRnq.pane-sendRuleBlockSelected_V0qHd.pane-eventRuleBlockSelected_TR5rE {
  box-shadow: 0 0 4px rgba(183, 183, 183, 0.75);
  background-color: #afe2c7;
  border-top-color: #23a78d;
  border-left-color: #23a78d;
  border-right-color: #23a78d;
  border-bottom-color: #23a78d;
}
.pane_ajaBp.pane-ruleItem_b6H05.pane-debugRuleBlock_uroXZ {
  background-color: #f6f6fa;
  border-top-color: #382cdd;
  border-left-color: #382cdd;
  border-right-color: #382cdd;
  border-bottom-color: #382cdd;
}
.pane_ajaBp.pane-ruleItem_b6H05.pane-ruleBlock_DyThC.pane-ruleBlockSelected_UbRnq.pane-debugRuleBlockSelected_cTUMu {
  background-color: #bfb2ea;
  border-top-color: #382cdd;
  border-left-color: #382cdd;
  border-right-color: #382cdd;
  border-bottom-color: #382cdd;
}
.pane_ajaBp.pane-ruleBlockPropertySheet_GjIOT {
  min-width: 500px;
  box-shadow: -1px 0px 7px rgba(0, 0, 0, 0.05);
  border-left: 1px solid var( --color-base100 );
  background-color: var( --color-white );
}
.pane_ajaBp.pane-ruleBlockPropertySheetHeader_gfNrW {
  padding: var( --size-padMedium );
  border-bottom: 1px solid var( --color-base100 );
  background-color: var( --color-white );
}
.pane_ajaBp.pane-footerItemBar_qEuGE {
  margin-top: var( --size-padSmall );
  margin-left: var( --size-padMedium );
  margin-bottom: var( --size-padSmall );
}
.pane_ajaBp.pane-ruleItem_b6H05.pane-ruleBlock_DyThC.pane-computeRuleBlock_t7bSU {
  background-color: #e9eefc;
  border-top-width: 1px;
  border-top-color: #1646c5;
  border-left-width: 1px;
  border-left-color: #1646c5;
  border-right-width: 1px;
  border-right-color: #1646c5;
  border-bottom-width: 1px;
  border-bottom-color: #1646c5;
}
.pane_ajaBp.pane-ruleItem_b6H05.pane-ruleBlock_DyThC.pane-ruleBlockSelected_UbRnq.pane-sendRuleBlockSelected_V0qHd.pane-computeRuleBlockSelected_W39y0 {
  border: 2px dashed #1646c5;
  background-color: #a4b7ef;
}
.pane_ajaBp.pane-templateEditor_fHkJk {
  border: 1px solid var( --color-base025 );
  margin: 0px;
  text-align: left;
  border-radius: var( --size-padSmall );
  background-color: var( --color-base050 );
}
.pane_ajaBp.pane-templateTagEditor_j1sjD {
  padding: var( --size-padLarge );
}
.pane_ajaBp.pane-detailGraphCard_l9FSd {
  border-top-color: var( --color-base050 );
  border-left-color: var( --color-base050 );
  border-right-color: var( --color-base050 );
  border-bottom-color: var( --color-base050 );
}
.pane_ajaBp.pane-aggregationCardItem_atENr {
  padding: var( --size-padLarge );
  border-top-width: 0px;
  border-left-width: 0px;
  border-right-width: 0px;
  border-bottom-width: 0px;
}
.pane_ajaBp.pane-operatingHoursDayEven_FmNrq {
  background-color: var( --color-base025 );
}
.pane_ajaBp.pane-operatingHoursDayOdd_t8FhX {
  background-color: var( --color-white );
}
.pane_ajaBp.pane-detail_ougWm.pane-detailCard_iw3Dk.pane-detailBigCard_STB4q {
  padding-bottom: 16px;
}
.pane_ajaBp.pane-dashboardCardEditor_Y4lV0.pane-dashboardCard_fgmtj.pane-dashboardSecondaryCard__28N8 {
  border-top-left-radius: var( --size-medium );
  border-top-right-radius: var( --size-medium );
  border-bottom-left-radius: 0px;
  border-bottom-right-radius: 0px;
}
.pane_ajaBp.pane-dashboardCardEditor_Y4lV0.pane-dashboardCard_fgmtj.pane-dashboardSectionCard_j4Aep {
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
  border-bottom-left-radius: var( --size-medium );
  border-bottom-right-radius: var( --size-medium );
}
.pane_ajaBp.pane-formBody_o6CCf.pane-twoStepContent_woEUd.pane-twoStepRequiredContent_OEQjQ {
  width: auto;
  max-height: 400px;
  background-color: transparent;
}
.pane_ajaBp.pane-passwordRequirements_Zp2g8 {
  padding: var( --size-padMedium ) 0px 8px;
  border-radius: 4px;
  background-color: transparent;
}
.pane_ajaBp.pane-releaseAvailableOverlay_x0sDX {
  color: var( --color-brand700 );
  border: 1px solid var( --color-brand700 );
  padding: var( --size-padMedium );
  border-radius: 4px;
  background-color: var( --color-brand100 );
}
.pane_ajaBp.pane-topNavBreadcrumbs_FJXpN {
  border-top: 0px solid var( --color-base200 );
  background-color: var( --color-white );
}
.pane_ajaBp.pane-mainScreenHeader_qmeRi {
  border-bottom: 1px solid var( --color-base200 );
}
.pane_ajaBp.pane-topNavBreadcrumbs_FJXpN.pane-mobileTopNavBreadcrumbs_uFMhf {
  border-bottom: 1px solid var( --color-base200 );
}
.pane_ajaBp.pane-pairing_LtNBe {
  border-radius: 4px;
}
.pane_ajaBp.pane-pairContent_hdFEw.pane-pairContentArea_PVlPO {
  padding: var( --size-padLarge );
  min-height: 350px;
  background-color: var( --color-base050 );
}
.pane_ajaBp.pane-pairContent_hdFEw.pane-pairContentFooter_LOiml {
  padding: var( --size-padLarge );
  background-color: var( --color-white );
}
.pane_ajaBp.pane-pairEditor_QIvz2 {
  width: 500px;
  padding: var( --size-padLarge );
  max-width: 100vw;
  max-height: 100vh;
  background-color: var( --color-base025 );
}
.pane_ajaBp.pane-deviceSelectorHeader_NumSx {
  padding: var( --size-padLarge ) var( --size-padLarge ) 0px;
}
.pane_ajaBp.pane-deviceSelectorContent_WxPns {
  padding: var( --size-padLarge );
}
.pane_ajaBp.pane-dialog_FXK8m.pane-attributeEditorDialog_mfhyW {
  padding: var( --size-padMedium );
}
.pane_ajaBp.pane-editor_NYR8U.pane-imageEditor_Kg7F2 {
  padding: 0px;
  min-width: auto;
  background-color: transparent;
}
.pane_ajaBp.pane-detail_ougWm.pane-detailCard_iw3Dk.pane-detailCardNoShadow_hoB5M {
  width: 100%;
  border: 1px solid var( --color-base200 );
  box-shadow: none;
}
.pane_ajaBp.pane-array_v3vXr {
  padding: 0px var( --size-padLarge );
}
.pane_ajaBp.pane-CustomTextEditor_KmYw_ {
  min-height: 100%;
  background-color: var( --color-base025 );
}
.pane_ajaBp.pane-customTextEditorMenuActionBar_U1YhJ {
  padding: 8px 16px;
  border-bottom: 1px solid var( --color-base200 );
  background-color: var( --color-white );
}
.pane_ajaBp.pane-customTextValueEditor_iu8i2 {
  padding: var( --size-padMedium );
}
.pane_ajaBp.pane-customTextMenu_qg0s3 {
  padding: var( --size-padMedium );
  border-bottom: 1px solid var( --color-base200 );
  background-color: var( --color-white );
  border-top-width: 0px;
  border-left-width: 0px;
  border-right-width: 0px;
}
.pane_ajaBp.pane-tempUserEditorBody_ow7kv {
  padding: var( --size-padMedium );
  background-color: var( --color-base050 );
}
.pane_ajaBp.pane-tempUserEditorHeader_yyDVu {
  padding: var( --size-padMedium );
  border-bottom: 1px solid var( --color-base100 );
}
.pane_ajaBp.pane-tempUserEditorFooter_h5EDg {
  border-top: 1px solid var( --color-base100 );
}
.pane_ajaBp.pane-loginPane_kl1fh.pane-temporaryUserLoginPane_gJp9A {
  padding-top: 80px;
  padding-bottom: 80px;
}
.pane_ajaBp.pane-editorDialog_g0A_m.pane-tempUserEditorDialog_zJeRA {
  width: 496px;
}
.pane_ajaBp.pane-shareTempUserBody_NwCnY {
  padding: var( --size-padMedium );
  border-top: 1px solid var( --color-base100 );
  border-bottom: 1px solid var( --color-base100 );
  background-color: var( --color-white );
}
.pane_ajaBp.pane-attributeTableGeoPointEditor_M4cMb {
  width: 100%;
  height: 100%;
}
.pane_ajaBp.pane-attributeTablePercentEditor_AH_iW {
  width: 100%;
}
.pane_ajaBp.pane-array_v3vXr.pane-tableArray_kuT3y {
  padding: 0px var( --size-padMedium );
  margin-top: var( --size-padSmall );
  margin-bottom: var( --size-padSmall );
}
.pane_ajaBp.pane-detailArray_djvWq {
  padding: var( --size-padMedium ) var( --size-padLarge );
}
.pane_ajaBp.pane-attributeCustomText_QRKLq {
  padding-top: var( --size-padLarge );
  padding-bottom: var( --size-padLarge );
}
.pane_ajaBp.pane-formLoadingView_uTVM7 {
  padding: var( --size-padMedium );
}
.pane_ajaBp.pane-detailImage_ppVWP {
  padding-left: var( --size-padMedium );
  padding-right: var( --size-padMedium );
}
.pane_ajaBp.pane-collectionEditorTreeSection_ri9D5 {
  width: 400px;
}
.pane_ajaBp.pane-tvCollectionView_V2qj9 {
  padding: var( --size-padLarge );
  background-color: var( --color-white );
}
.pane_ajaBp.pane-card_kwSo4.pane-tvCollectionViewItem_mTK8u {
  background-color: var( --color-brand050 );
}
.pane_ajaBp.pane-topNav_UyBl5.pane-mainNav_HOfZF {
  height: 100%;
  background-color: var( --color-mainNavPane );
}
.pane_ajaBp.pane-loginPane_kl1fh.pane-deviceCodeInfo_gp2I3 {
  box-shadow: none;
}
.pane_ajaBp.pane-loginPaneHalf_e1L9X {
  width: 316px;
  max-width: 80vw;
}
.pane_ajaBp.pane-deviceQRCode_VqLTD {
  padding: var( --size-padMedium );
  border-radius: 8px;
  background-color: var( --color-brand025 );
}
.pane_ajaBp.pane-deviceQRCode_VqLTD.pane-deviceQRCodeError_G89hn {
  padding: var( --size-padLarge );
  min-height: 200px;
  background-color: var( --color-danger100 );
}
.pane_ajaBp.pane-imageListEditor_kwPct {
  width: 720px;
  height: 720px;
}
.pane_ajaBp.pane-dialog_FXK8m.pane-ignoreAlertPreferences_pgKzV {
  max-width: 30vw;
}
.pane_ajaBp.pane-dialog_FXK8m.pane-runInference_NlHIn {
  max-width: auto;
}
.pane_ajaBp.pane-detail_ougWm.pane-detailCard_iw3Dk.pane-detailRsrcCard_KR2UE {
  box-shadow: none;
  border-radius: 0px;
}
.pane_ajaBp.pane-galleryItem_IOJhU {
  border: 1px solid var( --color-base200 );
  border-radius: 8px;
}
.pane_ajaBp.pane-galleryItem_IOJhU:hover {
  border: 1px solid var( --color-brand500 );
  box-shadow: 0 1px 3px var( --color-shadowBase );
}
.pane_ajaBp.pane-galleryItem_IOJhU:active {
  border: 1px solid var( --color-brand900 );
}
.pane_ajaBp.pane-rsrcImageDetail_AkgcF {
  width: 100dvw;
  height: 100dvh;
  background-color: #000000;
}
.pane_ajaBp.pane-rsrcImageDetailTitle_yVeFu {
  padding: var( --size-padXLarge );
  background: linear-gradient(0deg, rgba(0, 0, 0, 0), #000000 100%);
}
.pane_ajaBp.pane-rsrcEditorFooter_xmzEO {
  padding: var( --size-padLarge ) var( --size-padMedium );
}
.pane_ajaBp.pane-rsrcEditorArea_KrNmW {
  background-color: var( --color-base025 );
}
.pane_ajaBp.pane-rsrcEditor_ZGDx3 {
  background-color: var( --color-white );
}
.pane_ajaBp.pane-listItem_IAl3k {
  padding-left: var( --size-padMedium );
  border-bottom: 1px solid var( --color-base050 );
  padding-right: var( --size-padMedium );
}
.pane_ajaBp.pane-thumbnail_a9qYa {
  box-shadow: 0 4px 8px rgba( 0, 0, 0, 0.2 );
  border-radius: 8px;
  background-color: var( --color-base025 );
}
.pane_ajaBp.pane-thumbnail_a9qYa:hover {
  border: 1px solid var( --color-base200 );
}
.pane_ajaBp.pane-thumbnailTop_wuLEw {
  border-bottom: 1px solid var( --color-base200 );
}
.pane_ajaBp.pane-thumbnailBottom_KWGHy {
  padding: 8px;
}
.pane_ajaBp.pane-dialog_FXK8m.pane-dialogLarge_Gbb0B {
  width: 60%;
}
.pane_ajaBp.pane-dialog_FXK8m.pane-dialogLarge_Gbb0B.pane-dialogMedium_DrTCJ {
  width: 40%;
}
.pane_ajaBp.pane-project_jnpOy {
  width: 280px;
  height: 160px;
  padding: var( --size-padLarge );
  box-shadow: 0 1px 3px var( --color-shadowBase );
  margin-right: var( --size-padXLarge );
  border-radius: var( --size-borderRadiusMedium );
  margin-bottom: var( --size-padXLarge );
  background-color: var( --color-white );
}
.pane_ajaBp.pane-project_jnpOy:hover {
  box-shadow: 0 8px 16px var( --color-shadowBase ),0 0px 1px var( --color-shadowBase );
}
.pane_ajaBp.pane-project_jnpOy:active {
  box-shadow: 0 0px 2px rgba( 0, 0, 0, 0.2 );
  transition: all 0s;
}
.pane_ajaBp.pane-dialogContent_B4P8x.pane-projectDialogContent_kVaiw {
  height: 100%;
}
.pane_ajaBp.pane-listEditorHeader__xYdQ {
  padding: var( --size-padMedium );
  border-right: 3px solid var( --color-base100 );
  border-bottom: 3px solid var( --color-base100 );
}
.pane_ajaBp.pane-listEditorList_MvD9P {
  border-right: 3px solid var( --color-base100 );
  border-top-color: var( --color-base100 );
  border-left-color: var( --color-base100 );
  border-bottom-color: var( --color-base100 );
}
.pane_ajaBp.pane-listEditorList_MvD9P.pane-listEditorFooter_cE5pi {
  padding: var( --size-padMedium );
  border-top: 3px solid var( --color-base100 );
  border-right: 3px solid var( --color-base100 );
}
.pane_ajaBp.pane-dialog_FXK8m.pane-attributeEditor_tOd_1 {
  border-radius: 0px;
}
.pane_ajaBp.pane-dialogHeader_kCcQX.pane-attributeEditorHeader_rHHjh {
  color: #c51b67;
  padding: var( --size-padMedium );
  text-transform: uppercase;
  background-color: var( --color-base100 );
}
.pane_ajaBp.pane-content_pK4zZ {
  background-color: var( --color-base100 );
}
.pane_ajaBp.pane-contentSidebar_hK1xq {
  box-shadow: 0 1px 3px var( --color-shadowBase );
  border-right: 1px solid var( --color-base100 );
  background-color: var( --color-base025 );
}
.pane_ajaBp.pane-card_kwSo4.pane-enumCard_l4WCU {
  padding: 0px;
}
.pane_ajaBp.pane-card_kwSo4.pane-enumCard_l4WCU:hover {
  box-shadow: 0 4px 8px var( --color-brand050 );
}
.pane_ajaBp.pane-card_kwSo4.pane-enumCard_l4WCU:focus {
  border-top-color: var( --color-base400 );
  border-left-color: var( --color-base400 );
  border-right-color: var( --color-base400 );
  border-bottom-color: var( --color-base400 );
}
.pane_ajaBp.pane-profileContent_DGud1 {
  padding: var( --size-padSmall );
}
.pane_ajaBp.pane-pill_h_Rtd.pane-valueSourcePill_tEDU_ {
  background-color: var( --color-white );
}
.pane_ajaBp.pane-editor_NYR8U.pane-itemEditor_TJTpw {
  height: 100%;
  border-left: 1px solid var( --color-base200 );
}
.pane_ajaBp.pane-dialog_FXK8m.pane-ruleDialog_tfwgN {
  min-width: 30vw;
}
.pane_ajaBp.pane-ruleItem_b6H05.pane-sendRuleBlock_rpkSa.pane-commentRuleBlock_C56Ko {
  max-width: 450px;
  border-top-width: 2px;
  border-left-width: 2px;
  border-right-width: 2px;
  border-bottom-width: 2px;
}
.pane_ajaBp.pane-ruleItem_b6H05.pane-ruleBlock_DyThC.pane-ruleBlockSelected_UbRnq.pane-sendRuleBlockSelected_V0qHd.pane-commentRuleBlockSelected_Q9Mqz {
  max-width: 450px;
}
.pane-sortFilterBar_GUjSt {
  height: 48px;
  padding: 4px 16px;
  min-height: auto;
  border-bottom: 1px solid var( --color-base200 );
  background-color: var( --color-base025 );
}
.pane-resourceImageValue_Jyz81 {
  padding: var( --size-padMedium );
}`, "",{"version":3,"sources":["webpack://./src/theme/Pane.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;AAC7B;AACA;EACE,+BAA+B;EAC/B,sCAAsC;AACxC;AACA;EACE,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,oFAAoF;EACpF,sBAAsB;EACtB,yCAAyC;AAC3C;AACA;EACE,wCAAwC;EACxC,gCAAgC;EAChC,oFAAoF;EACpF,kBAAkB;EAClB,sCAAsC;AACxC;AACA;EACE,+BAA+B;EAC/B,6BAA6B;EAC7B,qBAAqB;EACrB,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;AAC1B;AACA;EACE,2DAA2D;EAC3D,+CAA+C;AACjD;AACA;EACE,+BAA+B;EAC/B,iBAAiB;EACjB,kBAAkB;EAClB,+CAA+C;EAC/C,sCAAsC;EACtC,2BAA2B;EAC3B,4BAA4B;AAC9B;AACA;EACE,+BAA+B;EAC/B,4CAA4C;EAC5C,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,wCAAwC;AAC1C;AACA;EACE,+BAA+B;EAC/B,4CAA4C;EAC5C,wBAAwB;EACxB,8BAA8B;EAC9B,+BAA+B;AACjC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,qCAAqC;EACrC,sCAAsC;EACtC,wCAAwC;AAC1C;AACA;EACE,+BAA+B;AACjC;AACA;EACE,UAAU;EACV,oFAAoF;EACpF,gBAAgB;EAChB,kBAAkB;EAClB,sCAAsC;AACxC;AACA;EACE,0CAA0C;EAC1C,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,6CAA6C;AAC/C;AACA;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,sCAAsC;AACxC;AACA;EACE,aAAa;EACb,sCAAsC;AACxC;AACA;EACE,WAAW;EACX,+BAA+B;EAC/B,+CAA+C;EAC/C,mCAAmC;EACnC,sCAAsC;AACxC;AACA;EACE,YAAY;EACZ,sCAAsC;AACxC;AACA;EACE,uDAAuD;EACvD,sCAAsC;EACtC,8CAA8C;EAC9C,+CAA+C;AACjD;AACA;EACE,+BAA+B;AACjC;AACA;EACE,YAAY;EACZ,wCAAwC;AAC1C;AACA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,qCAAqC;EACrC,mBAAmB;AACrB;AACA;EACE,+BAA+B;EAC/B,UAAU;EACV,+CAA+C;EAC/C,wCAAwC;AAC1C;AACA;EACE,+BAA+B;EAC/B,sCAAsC;AACxC;AACA;EACE,WAAW;EACX,YAAY;EACZ,wCAAwC;AAC1C;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+BAA+B;AACjC;AACA;EACE,YAAY;EACZ,+BAA+B;EAC/B,+CAA+C;AACjD;AACA;EACE,YAAY;EACZ,+CAA+C;EAC/C,qCAAqC;EACrC,sCAAsC;EACtC,sCAAsC;AACxC;AACA;EACE,YAAY;EACZ,+BAA+B;EAC/B,gBAAgB;AAClB;AACA;EACE,2EAA2E;EAC3E,UAAU;EACV,+CAA+C;EAC/C,gBAAgB;AAClB;AACA;EACE,+BAA+B;AACjC;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,0CAA0C;EAC1C,sCAAsC;EACtC,qBAAqB;EACrB,wCAAwC;EACxC,sBAAsB;EACtB,yCAAyC;EACzC,uBAAuB;EACvB,0CAA0C;EAC1C,wBAAwB;EACxB,2CAA2C;AAC7C;AACA;EACE,oCAAoC;EACpC,uCAAuC;AACzC;AACA;EACE,sCAAsC;AACxC;AACA;EACE,WAAW;EACX,8CAA8C;EAC9C,sCAAsC;AACxC;AACA;EACE,uDAAuD;AACzD;AACA;EACE,YAAY;EACZ,sCAAsC;AACxC;AACA;EACE,gCAAgC;EAChC,+CAA+C;EAC/C,wCAAwC;AAC1C;AACA;EACE,sCAAsC;AACxC;AACA;EACE,gBAAgB;AAClB;AACA;EACE,+CAA+C;AACjD;AACA;EACE,kCAAkC;EAClC,sCAAsC;AACxC;AACA;EACE,WAAW;EACX,gCAAgC;EAChC,gBAAgB;EAChB,sCAAsC;AACxC;AACA;EACE,gBAAgB;EAChB,sCAAsC;AACxC;AACA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,+CAA+C;AACjD;AACA;EACE,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,0DAA0D;AAC5D;AACA;EACE,YAAY;EACZ,iDAAiD;AACnD;AACA;EACE,+BAA+B;EAC/B,wCAAwC;AAC1C;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,+CAA+C;AACjD;AACA;EACE,uDAAuD;EACvD,+CAA+C;AACjD;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,iIAAiI;AACnI;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gBAAgB;EAChB,+CAA+C;AACjD;AACA;EACE,+BAA+B;EAC/B,6BAA6B;AAC/B;AACA;EACE,+BAA+B;EAC/B,+CAA+C;EAC/C,kCAAkC;EAClC,sCAAsC;AACxC;AACA;EACE,WAAW;EACX,YAAY;EACZ,sCAAsC;AACxC;AACA;EACE,WAAW;AACb;AACA;EACE,+BAA+B;AACjC;AACA;EACE,yCAAyC;EACzC,gCAAgC;EAChC,kBAAkB;AACpB;AACA;EACE,mDAAmD;EACnD,sCAAsC;AACxC;AACA;EACE,sCAAsC;AACxC;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,yCAAyC;EACzC,iBAAiB;EACjB,kBAAkB;EAClB,wCAAwC;AAC1C;AACA;EACE,yCAAyC;EACzC,yCAAyC;EACzC,0CAA0C;EAC1C,2CAA2C;EAC3C,4CAA4C;AAC9C;AACA;EACE,sCAAsC;EACtC,kBAAkB;EAClB,wCAAwC;AAC1C;AACA;EACE,oCAAoC;AACtC;AACA;EACE,wCAAwC;EACxC,YAAY;EACZ,mCAAmC;EACnC,sCAAsC;AACxC;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,YAAY;EACZ,6BAA6B;AAC/B;AACA;EACE,yCAAyC;EACzC,yCAAyC;EACzC,0CAA0C;EAC1C,2CAA2C;EAC3C,4CAA4C;AAC9C;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;AAC1B;AACA;EACE,kBAAkB;EAClB,sCAAsC;AACxC;AACA;EACE,WAAW;EACX,YAAY;EACZ,sCAAsC;AACxC;AACA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,YAAY;AACd;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,sCAAsC;EACtC,4BAA4B;EAC5B,6BAA6B;AAC/B;AACA;EACE,0DAA0D;EAC1D,+CAA+C;AACjD;AACA;EACE,YAAY;EACZ,+CAA+C;AACjD;AACA;EACE,gCAAgC;EAChC,wCAAwC;AAC1C;AACA;EACE,+BAA+B;EAC/B,6BAA6B;AAC/B;AACA;EACE,WAAW;EACX,gCAAgC;EAChC,gBAAgB;EAChB,gBAAgB;EAChB,4CAA4C;EAC5C,gBAAgB;EAChB,6CAA6C;EAC7C,8CAA8C;EAC9C,+CAA+C;AACjD;AACA;EACE,qDAAqD;EACrD,mCAAmC;AACrC;AACA;EACE,kBAAkB;EAClB,+CAA+C;EAC/C,mBAAmB;EACnB,wCAAwC;AAC1C;AACA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,wCAAwC;EACxC,yCAAyC;EACzC,0CAA0C;EAC1C,2CAA2C;AAC7C;AACA;EACE,oCAAoC;EACpC,wCAAwC;AAC1C;AACA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,wCAAwC;AAC1C;AACA;EACE,+BAA+B;EAC/B,wCAAwC;AAC1C;AACA;EACE,+CAA+C;EAC/C,+CAA+C;EAC/C,wCAAwC;AAC1C;AACA;EACE,kBAAkB;EAClB,8CAA8C;EAC9C,wCAAwC;AAC1C;AACA;EACE,yCAAyC;EACzC,yCAAyC;AAC3C;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,gCAAgC;EAChC,sCAAsC;AACxC;AACA;EACE,+CAA+C;AACjD;AACA;EACE,sCAAsC;AACxC;AACA;EACE,YAAY;EACZ,aAAa;EACb,yEAAmH;AACrH;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,sCAAsC;AACxC;AACA;EACE,wCAAwC;EACxC,uDAAuD;EACvD,kBAAkB;EAClB,sCAAsC;AACxC;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,WAAW;AACb;AACA;EACE,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,gCAAgC;AAClC;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,wCAAwC;EACxC,+BAA+B;EAC/B,sCAAsC;EACtC,sCAAsC;AACxC;AACA;EACE,YAAY;EACZ,+BAA+B;EAC/B,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,wCAAwC;AAC1C;AACA;EACE,YAAY;EACZ,6BAA6B;EAC7B,8BAA8B;EAC9B,+BAA+B;EAC/B,gCAAgC;AAClC;AACA;EACE,YAAY;EACZ,wCAAwC;EACxC,gCAAgC;EAChC,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,+CAA+C;AACjD;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,sCAAsC;EACtC,4CAA4C;EAC5C,6CAA6C;AAC/C;AACA;EACE,+CAA+C;AACjD;AACA;EACE,YAAY;EACZ,+CAA+C;AACjD;AACA;EACE,kBAAkB;EAClB,+CAA+C;AACjD;AACA;EACE,WAAW;EACX,4CAA4C;EAC5C,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,sCAAsC;AACxC;AACA;EACE,+BAA+B;EAC/B,8CAA8C;EAC9C,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,yCAAyC;EACzC,+BAA+B;EAC/B,mCAAmC;EACnC,kBAAkB;EAClB,sCAAsC;EACtC,sCAAsC;AACxC;AACA;EACE,2CAA2C;EAC3C,4CAA4C;EAC5C,6CAA6C;EAC7C,8CAA8C;AAChD;AACA;EACE,0CAA0C;EAC1C,2CAA2C;EAC3C,4CAA4C;EAC5C,6CAA6C;AAC/C;AACA;EACE,wCAAwC;EACxC,gCAAgC;EAChC,qCAAqC;EACrC,yCAAyC;AAC3C;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,+BAA+B;EAC/B,+CAA+C;EAC/C,wCAAwC;AAC1C;AACA;EACE,wCAAwC;EACxC,gCAAgC;EAChC,kCAAkC;EAClC,wCAAwC;AAC1C;AACA;EACE,+BAA+B;EAC/B,wCAAwC;AAC1C;AACA;EACE,wCAAwC;EACxC,kBAAkB;EAClB,sCAAsC;AACxC;AACA;EACE,wCAAwC;EACxC,sCAAsC;AACxC;AACA;EACE,+BAA+B;EAC/B,+CAA+C;AACjD;AACA;EACE,mBAAmB;AACrB;AACA;EACE,oFAAoF;EACpF,kBAAkB;EAClB,sCAAsC;AACxC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,wCAAwC;EACxC,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,6BAA6B;AAC/B;AACA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,wCAAwC;AAC1C;AACA;EACE,WAAW;EACX,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,4CAA4C;AAC9C;AACA;EACE,4BAA4B;EAC5B,cAAc;EACd,wCAAwC;EACxC,sDAAsD;EACtD,gBAAgB;EAChB,qCAAqC;EACrC,oBAAoB;EACpB,sCAAsC;AACxC;AACA;EACE,YAAY;EACZ,eAAe;EACf,8CAA8C;EAC9C,kBAAkB;AACpB;AACA;EACE,yCAAyC;EACzC,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,wCAAwC;AAC1C;AACA;EACE,YAAY;AACd;AACA;EACE,wCAAwC;EACxC,kBAAkB;AACpB;AACA;EACE,gCAAgC;EAChC,sCAAsC;AACxC;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,+BAA+B;AACjC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,YAAY;EACZ,aAAa;EACb,sCAAsC;AACxC;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,sDAAsD;EACtD,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;EACpC,uCAAuC;AACzC;AACA;EACE,uBAAuB;AACzB;AACA;EACE,8EAA8E;AAChF;AACA;EACE,WAAW;EACX,aAAa;AACf;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,wCAAwC;AAC1C;AACA;EACE,gBAAgB;AAClB;AACA;EACE,oCAAoC;AACtC;AACA;EACE,0DAA0D;EAC1D,+CAA+C;EAC/C,qBAAqB;EACrB,wCAAwC;EACxC,sBAAsB;EACtB,yCAAyC;EACzC,uBAAuB;EACvB,0CAA0C;AAC5C;AACA;EACE,gCAAgC;EAChC,qBAAqB;EACrB,wCAAwC;EACxC,sBAAsB;EACtB,yCAAyC;EACzC,uBAAuB;EACvB,0CAA0C;EAC1C,wBAAwB;EACxB,2CAA2C;AAC7C;AACA;EACE,wCAAwC;EACxC,gCAAgC;EAChC,gBAAgB;EAChB,sCAAsC;AACxC;AACA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,yBAAyB;EACzB,wBAAwB;EACxB,0BAA0B;EAC1B,yBAAyB;EACzB,2BAA2B;EAC3B,0BAA0B;EAC1B,4BAA4B;AAC9B;AACA;EACE,0BAA0B;EAC1B,0CAA0C;EAC1C,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,yBAAyB;EACzB,sBAAsB;EACtB,0BAA0B;EAC1B,uBAAuB;EACvB,2BAA2B;EAC3B,wBAAwB;EACxB,4BAA4B;AAC9B;AACA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;AAC9B;AACA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,yBAAyB;EACzB,sBAAsB;EACtB,0BAA0B;EAC1B,uBAAuB;EACvB,2BAA2B;EAC3B,wBAAwB;EACxB,4BAA4B;AAC9B;AACA;EACE,0BAA0B;EAC1B,+CAA+C;EAC/C,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,yBAAyB;EACzB,sBAAsB;EACtB,0BAA0B;EAC1B,uBAAuB;EACvB,2BAA2B;EAC3B,wBAAwB;EACxB,4BAA4B;AAC9B;AACA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;AAC9B;AACA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,yBAAyB;EACzB,sBAAsB;EACtB,0BAA0B;EAC1B,uBAAuB;EACvB,2BAA2B;EAC3B,wBAAwB;EACxB,4BAA4B;AAC9B;AACA;EACE,6CAA6C;EAC7C,yBAAyB;EACzB,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;AAC9B;AACA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;AAC9B;AACA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;AAC9B;AACA;EACE,gBAAgB;EAChB,4CAA4C;EAC5C,6CAA6C;EAC7C,sCAAsC;AACxC;AACA;EACE,gCAAgC;EAChC,+CAA+C;EAC/C,sCAAsC;AACxC;AACA;EACE,kCAAkC;EAClC,oCAAoC;EACpC,qCAAqC;AACvC;AACA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,yBAAyB;EACzB,sBAAsB;EACtB,0BAA0B;EAC1B,uBAAuB;EACvB,2BAA2B;EAC3B,wBAAwB;EACxB,4BAA4B;AAC9B;AACA;EACE,0BAA0B;EAC1B,yBAAyB;AAC3B;AACA;EACE,wCAAwC;EACxC,WAAW;EACX,gBAAgB;EAChB,qCAAqC;EACrC,wCAAwC;AAC1C;AACA;EACE,+BAA+B;AACjC;AACA;EACE,wCAAwC;EACxC,yCAAyC;EACzC,0CAA0C;EAC1C,2CAA2C;AAC7C;AACA;EACE,+BAA+B;EAC/B,qBAAqB;EACrB,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;AAC1B;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,sCAAsC;AACxC;AACA;EACE,oBAAoB;AACtB;AACA;EACE,4CAA4C;EAC5C,6CAA6C;EAC7C,8BAA8B;EAC9B,+BAA+B;AACjC;AACA;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,+CAA+C;EAC/C,gDAAgD;AAClD;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,6BAA6B;AAC/B;AACA;EACE,wCAAwC;EACxC,kBAAkB;EAClB,6BAA6B;AAC/B;AACA;EACE,8BAA8B;EAC9B,yCAAyC;EACzC,gCAAgC;EAChC,kBAAkB;EAClB,yCAAyC;AAC3C;AACA;EACE,4CAA4C;EAC5C,sCAAsC;AACxC;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,kBAAkB;AACpB;AACA;EACE,+BAA+B;EAC/B,iBAAiB;EACjB,wCAAwC;AAC1C;AACA;EACE,+BAA+B;EAC/B,sCAAsC;AACxC;AACA;EACE,YAAY;EACZ,+BAA+B;EAC/B,gBAAgB;EAChB,iBAAiB;EACjB,wCAAwC;AAC1C;AACA;EACE,0DAA0D;AAC5D;AACA;EACE,+BAA+B;AACjC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,YAAY;EACZ,eAAe;EACf,6BAA6B;AAC/B;AACA;EACE,WAAW;EACX,wCAAwC;EACxC,gBAAgB;AAClB;AACA;EACE,mCAAmC;AACrC;AACA;EACE,gBAAgB;EAChB,wCAAwC;AAC1C;AACA;EACE,iBAAiB;EACjB,+CAA+C;EAC/C,sCAAsC;AACxC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;EAChC,+CAA+C;EAC/C,sCAAsC;EACtC,qBAAqB;EACrB,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,gCAAgC;EAChC,wCAAwC;AAC1C;AACA;EACE,gCAAgC;EAChC,+CAA+C;AACjD;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,YAAY;AACd;AACA;EACE,gCAAgC;EAChC,4CAA4C;EAC5C,+CAA+C;EAC/C,sCAAsC;AACxC;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;AACb;AACA;EACE,oCAAoC;EACpC,kCAAkC;EAClC,qCAAqC;AACvC;AACA;EACE,uDAAuD;AACzD;AACA;EACE,mCAAmC;EACnC,sCAAsC;AACxC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,qCAAqC;EACrC,sCAAsC;AACxC;AACA;EACE,YAAY;AACd;AACA;EACE,+BAA+B;EAC/B,sCAAsC;AACxC;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,YAAY;EACZ,4CAA4C;AAC9C;AACA;EACE,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,eAAe;AACjB;AACA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,yCAAyC;AAC3C;AACA;EACE,+BAA+B;EAC/B,iBAAiB;EACjB,0CAA0C;AAC5C;AACA;EACE,YAAY;EACZ,aAAa;AACf;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,wCAAwC;EACxC,kBAAkB;AACpB;AACA;EACE,yCAAyC;EACzC,+CAA+C;AACjD;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,aAAa;EACb,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,gCAAgC;EAChC,iEAAiE;AACnE;AACA;EACE,uDAAuD;AACzD;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,sCAAsC;AACxC;AACA;EACE,qCAAqC;EACrC,+CAA+C;EAC/C,sCAAsC;AACxC;AACA;EACE,0CAA0C;EAC1C,kBAAkB;EAClB,wCAAwC;AAC1C;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,+CAA+C;AACjD;AACA;EACE,YAAY;AACd;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,YAAY;EACZ,aAAa;EACb,+BAA+B;EAC/B,+CAA+C;EAC/C,qCAAqC;EACrC,+CAA+C;EAC/C,sCAAsC;EACtC,sCAAsC;AACxC;AACA;EACE,oFAAoF;AACtF;AACA;EACE,0CAA0C;EAC1C,kBAAkB;AACpB;AACA;EACE,YAAY;AACd;AACA;EACE,gCAAgC;EAChC,8CAA8C;EAC9C,+CAA+C;AACjD;AACA;EACE,8CAA8C;EAC9C,wCAAwC;EACxC,yCAAyC;EACzC,2CAA2C;AAC7C;AACA;EACE,gCAAgC;EAChC,4CAA4C;EAC5C,8CAA8C;AAChD;AACA;EACE,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,gCAAgC;EAChC,yBAAyB;EACzB,wCAAwC;AAC1C;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,+CAA+C;EAC/C,8CAA8C;EAC9C,wCAAwC;AAC1C;AACA;EACE,YAAY;AACd;AACA;EACE,6CAA6C;AAC/C;AACA;EACE,wCAAwC;EACxC,yCAAyC;EACzC,0CAA0C;EAC1C,2CAA2C;AAC7C;AACA;EACE,+BAA+B;AACjC;AACA;EACE,sCAAsC;AACxC;AACA;EACE,YAAY;EACZ,6CAA6C;AAC/C;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;AAC1B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,+CAA+C;EAC/C,wCAAwC;AAC1C;AACA;EACE,gCAAgC;AAClC","sourcesContent":[".pane {\n  transition: box-shadow 0.2s;\n}\n.pane.pane-overlay {\n  padding: var( --size-padLarge );\n  background-color: var( --color-white );\n}\n.pane.pane-overlay:hover {\n  box-shadow: none;\n}\n.pane.pane-navHeader {\n  border: none;\n  height: 50px;\n  box-shadow: 0 8px 16px var( --color-shadowBase ),0 0px 1px var( --color-shadowBase );\n  transition: width 0.4s;\n  background-color: var( --color-brand900 );\n}\n.pane.pane-loginPane {\n  border: 1px solid var( --color-base100 );\n  padding: var( --size-padXLarge );\n  box-shadow: 0 8px 16px var( --color-shadowBase ),0 0px 1px var( --color-shadowBase );\n  border-radius: 8px;\n  background-color: var( --color-white );\n}\n.pane.pane-contentSection {\n  padding: var( --size-padLarge );\n  background-color: transparent;\n  border-top-width: 0px;\n  border-left-width: 0px;\n  border-right-width: 0px;\n  border-bottom-width: 0px;\n}\n.pane.pane-contentSection.pane-contentBorder {\n  padding: var( --size-padLarge ) var( --size-padLarge ) 24px;\n  border-bottom: 1px solid var( --color-base200 );\n}\n.pane.pane-formHeader {\n  padding: var( --size-padLarge );\n  border-left: none;\n  border-right: none;\n  border-bottom: 2px solid var( --color-base100 );\n  background-color: var( --color-white );\n  border-top-left-radius: 4px;\n  border-top-right-radius: 4px;\n}\n.pane.pane-formBody {\n  padding: var( --size-padLarge );\n  border-top: 1px solid var( --color-base050 );\n  border-left: none;\n  border-right: none;\n  border-bottom: none;\n  background-color: var( --color-base025 );\n}\n.pane.pane-formHeader.pane-formButtons {\n  padding: var( --size-padLarge );\n  border-top: 1px solid var( --color-base100 );\n  border-bottom-width: 0px;\n  border-bottom-left-radius: 4px;\n  border-bottom-right-radius: 4px;\n}\n.pane.pane-dialogHeader {\n  padding: var( --size-padLarge );\n}\n.pane.pane-dialogBody {\n  width: auto;\n  max-width: 50000px;\n  padding-left: var( --size-padMedium );\n  padding-right: var( --size-padMedium );\n  background-color: var( --color-base050 );\n}\n.pane.pane-dialogFooter {\n  padding: var( --size-padLarge );\n}\n.pane.pane-dialog {\n  z-index: 1;\n  box-shadow: 0 8px 16px var( --color-shadowBase ),0 0px 1px var( --color-shadowBase );\n  max-height: 80vh;\n  border-radius: 8px;\n  background-color: var( --color-white );\n}\n.pane.pane-loginWarning {\n  border: 1px solid var( --color-danger100 );\n  padding: var( --size-padMedium );\n  margin-top: 16px;\n  min-height: 0px;\n  border-radius: 4px;\n  margin-bottom: 0px;\n  background-color: var( --color-shadowDanger );\n}\n.pane.pane-formGeoshape {\n  padding: var( --size-padLarge );\n  border-radius: 4px;\n  background-color: var( --color-white );\n}\n.pane.pane-contentSection.pane-contentSectionWhite {\n  padding: 56px;\n  background-color: var( --color-white );\n}\n.pane.pane-card {\n  width: 100%;\n  padding: var( --size-padLarge );\n  box-shadow: 0 1px 3px var( --color-shadowBase );\n  border-radius: var( --size-medium );\n  background-color: var( --color-white );\n}\n.pane.pane-mobileTabPortal {\n  height: 100%;\n  background-color: var( --color-white );\n}\n.pane.pane-mobileActions {\n  padding: var( --size-padXLarge ) var( --size-padLarge );\n  background-color: var( --color-white );\n  border-top-left-radius: var( --size-padLarge );\n  border-top-right-radius: var( --size-padLarge );\n}\n.pane.pane-mobileTabsHeader {\n  padding: var( --size-padLarge );\n}\n.pane.pane-mobileList {\n  height: 100%;\n  background-color: var( --color-base050 );\n}\n.pane.pane-mobileMapToggle {\n  margin-left: var( --size-padMedium );\n  padding-left: 12px;\n  margin-right: var( --size-padMedium );\n  padding-right: 40px;\n}\n.pane.pane-mobileItemHeader {\n  padding: var( --size-padLarge );\n  z-index: 1;\n  box-shadow: 0 1px 3px var( --color-shadowBase );\n  background-color: var( --color-base050 );\n}\n.pane.pane-mobileItemBody {\n  padding: var( --size-padLarge );\n  background-color: var( --color-white );\n}\n.pane.pane-mobileList.pane-mobileListSettings {\n  width: 100%;\n  height: 100%;\n  background-color: var( --color-base050 );\n}\n.pane.pane-mobileTabsHeader.pane-mobileDtrHeader {\n  box-shadow: 0 1px 3px var( --color-shadowBase );\n}\n.pane.pane-mobileDtrContent {\n  padding: var( --size-padLarge );\n}\n.pane.pane-sidebar {\n  height: 100%;\n  padding: var( --size-padLarge );\n  box-shadow: 0 1px 3px var( --color-shadowBase );\n}\n.pane.pane-tablePagination {\n  height: 64px;\n  box-shadow: 0 1px 3px var( --color-shadowBase );\n  padding-left: var( --size-padMedium );\n  padding-right: var( --size-padMedium );\n  background-color: var( --color-white );\n}\n.pane.pane-editPageSizeOverlay {\n  width: 100vw;\n  padding: var( --size-padLarge );\n  max-width: 412px;\n}\n.pane.pane-rootHeader {\n  padding: var( --size-padMedium ) var( --size-padLarge ) var( --size-pad12 );\n  z-index: 2;\n  box-shadow: 0 1px 3px var( --color-shadowBase );\n  min-height: 64px;\n}\n.pane.pane-dataCard {\n  padding: var( --size-padLarge );\n}\n.pane.pane-card.pane-graphContainer {\n  padding-left: 0px;\n  padding-right: 0px;\n}\n.pane.pane-detail.pane-detailCard {\n  box-shadow: 0 4px 8px rgba( 0, 0, 0, 0.2 );\n  background-color: var( --color-white );\n  border-top-width: 1px;\n  border-top-color: var( --color-base100 );\n  border-left-width: 1px;\n  border-left-color: var( --color-base100 );\n  border-right-width: 1px;\n  border-right-color: var( --color-base100 );\n  border-bottom-width: 1px;\n  border-bottom-color: var( --color-base100 );\n}\n.pane.pane-dialogHeader.pane-detailHeader {\n  padding-top: var( --size-padMedium );\n  padding-bottom: var( --size-padMedium );\n}\n.pane.pane-detailContent {\n  background-color: var( --color-white );\n}\n.pane.pane-collectionEditorListSection {\n  margin: 0px;\n  border-right: 1px solid var( --color-base100 );\n  background-color: var( --color-white );\n}\n.pane.pane-collectionEditorListHeader {\n  padding: var( --size-padMedium ) var( --size-padLarge );\n}\n.pane.pane-collectionEditorSelectionSection {\n  padding: 0px;\n  background-color: var( --color-white );\n}\n.pane.pane-collectionEditorSelectionHeader {\n  padding: var( --size-padMedium );\n  border-bottom: 1px solid var( --color-base200 );\n  background-color: var( --color-base050 );\n}\n.pane.pane-collectionEditorSelectionContent {\n  background-color: var( --color-white );\n}\n.pane.pane-dialogContent {\n  max-height: 80vh;\n}\n.pane.pane-rootEditorContent {\n  border-bottom: 2px solid var( --color-base200 );\n}\n.pane.pane-editorDialog {\n  border-radius: var( --size-small );\n  background-color: var( --color-white );\n}\n.pane.pane-editor {\n  width: 100%;\n  padding: var( --size-padMedium );\n  min-width: 400px;\n  background-color: var( --color-white );\n}\n.pane.pane-formFooter {\n  border-top: none;\n  background-color: var( --color-white );\n}\n.pane.pane-screenTitle {\n  padding: var( --size-padLarge );\n  min-height: 72px;\n  border-bottom: 1px solid var( --color-base200 );\n}\n.pane.pane-topNav {\n  height: 56px;\n  padding-right: 8px;\n}\n.pane.pane-tableFilter {\n  height: 100%;\n  padding: var( --size-padLarge ) var( --size-padLarge ) 0px;\n}\n.pane.pane-sideNav {\n  height: 100%;\n  box-shadow: 1px 0px 3px var( --color-shadowBase );\n}\n.pane.pane-screenContent {\n  padding: var( --size-padLarge );\n  background-color: var( --color-base025 );\n}\n.pane.pane-actionBar {\n  background-color: transparent;\n}\n.pane.pane-aggregation {\n  border-bottom: 1px solid var( --color-base100 );\n}\n.pane.pane-dialogTitle {\n  padding: var( --size-padMedium ) var( --size-padLarge );\n  border-bottom: 2px solid var( --color-base100 );\n}\n.pane.pane-rootEditorHeader {\n  z-index: 1;\n}\n.pane.pane-rootEditorFooter {\n  z-index: 1;\n}\n.pane.pane-detail.pane-listDetail {\n  box-shadow: none;\n  border-radius: 0px;\n}\n.pane.pane-loginBackground {\n  background: url(\"https://storage.googleapis.com/molten-ui-assets/login_background.jpeg\") center center / cover no-repeat, #080613;\n}\n.pane.pane-mobileDetail {\n  border-bottom: 1px solid var( --color-base100 );\n}\n.pane.pane-cowList {\n  box-shadow: none;\n  border-bottom: 1px solid var( --color-base200 );\n}\n.pane.pane-navSecondaryMobile {\n  padding: var( --size-padLarge );\n  background-color: transparent;\n}\n.pane.pane-mapActionBar {\n  padding: var( --size-padSmall );\n  box-shadow: 0 1px 3px var( --color-shadowBase );\n  border-radius: var( --size-small );\n  background-color: var( --color-white );\n}\n.pane.pane-mobileMainNav {\n  width: 80vw;\n  height: 100%;\n  background-color: var( --color-white );\n}\n.pane.pane-mobileNavRoutes {\n  width: 100%;\n}\n.pane.pane-mobileNavUser {\n  padding: var( --size-padLarge );\n}\n.pane.pane-dashboardCardEditor {\n  border: 1px dashed var( --color-base400 );\n  padding: var( --size-padMedium );\n  border-radius: 4px;\n}\n.pane.pane-dashboardCardEditorHeader {\n  padding: var( --size-pad12 ) var( --size-padLarge );\n  background-color: var( --color-white );\n}\n.pane.pane-dashboardCardEditorArea {\n  background-color: var( --color-white );\n}\n.pane.pane-itemDashboard {\n  background-color: var( --color-base050 );\n}\n.pane.pane-dashboardPlaceholderCard {\n  border: 1px dashed var( --color-base400 );\n  min-height: 100px;\n  border-radius: 4px;\n  background-color: var( --color-base100 );\n}\n.pane.pane-dashboardPlaceholderCard.pane-dashboardPlaceholderCardHighlight {\n  background-color: var( --color-brand050 );\n  border-top-color: var( --color-brand300 );\n  border-left-color: var( --color-brand300 );\n  border-right-color: var( --color-brand300 );\n  border-bottom-color: var( --color-brand300 );\n}\n.pane.pane-dashboardNoData {\n  padding: 100px var( --size-padXLarge );\n  border-radius: 8px;\n  background-color: var( --color-base100 );\n}\n.pane.pane-dashboardCardEditorHeader.pane-dashboardCardHeader {\n  padding-top: var( --size-padMedium );\n}\n.pane.pane-dashboardCardEditor.pane-dashboardCard {\n  border: 1px solid var( --color-base200 );\n  padding: 0px;\n  border-radius: var( --size-medium );\n  background-color: var( --color-white );\n}\n.pane.pane-dashboardCardEditor.pane-dashboardCard.pane-dashboardTransparentCard {\n  background-color: var( --color-brand100 );\n}\n.pane.pane-dashboardCardEditor.pane-dashboardTransparentCardEditor {\n  background-color: var( --color-brand100 );\n}\n.pane.pane-dashboardCardEditor.pane-dashboardCard.pane-dashboardGridCard {\n  border: none;\n  background-color: transparent;\n}\n.pane.pane-dashboardCardEditor.pane-dashboardCardEditorTarget {\n  background-color: var( --color-brand100 );\n  border-top-color: var( --color-brand500 );\n  border-left-color: var( --color-brand500 );\n  border-right-color: var( --color-brand500 );\n  border-bottom-color: var( --color-brand500 );\n}\n.pane.pane-suggestions {\n  width: 448px;\n  box-shadow: none;\n  border-top-width: 0px;\n  border-left-width: 0px;\n  border-right-width: 0px;\n  border-bottom-width: 0px;\n}\n.pane.pane-itemForm {\n  border-radius: 4px;\n  background-color: var( --color-white );\n}\n.pane.pane-mobileItemForm {\n  width: 100%;\n  height: 100%;\n  background-color: var( --color-white );\n}\n.pane.pane-formBody.pane-mobileItemFormBody {\n  width: 100%;\n  height: 100%;\n  max-height: 100%;\n}\n.pane.pane-formHeader.pane-mobileItemFormHeader {\n  padding: 0px;\n}\n.pane.pane-navSecondaryMobileContainer {\n  margin-top: 20%;\n  padding-top: 2px;\n  padding-bottom: 2px;\n  background-color: var( --color-white );\n  border-top-left-radius: 16px;\n  border-top-right-radius: 16px;\n}\n.pane.pane-mobileSearchHeader {\n  padding: 0px var( --size-padLarge ) var( --size-padLarge );\n  border-bottom: 1px solid var( --color-base100 );\n}\n.pane.pane-mobileMainHeader {\n  padding: 4px;\n  box-shadow: 0 1px 3px var( --color-shadowBase );\n}\n.pane.pane-dashboardGridCardEditorArea {\n  padding: var( --size-padMedium );\n  background-color: var( --color-base100 );\n}\n.pane.pane-itemDashboardContent {\n  padding: var( --size-padLarge );\n  background-color: transparent;\n}\n.pane.pane-aggregationItem {\n  margin: 0px;\n  padding: var( --size-padMedium );\n  min-width: 100px;\n  text-align: left;\n  border-top: 0px solid var( --color-base200 );\n  min-height: 80px;\n  border-left: 0px solid var( --color-base200 );\n  border-right: 1px solid var( --color-base200 );\n  border-bottom: 0px solid var( --color-base200 );\n}\n.pane.pane-mobileSimpleSearchArea {\n  box-shadow: inset 0 1px 3px var( --color-shadowBase );\n  padding-top: var( --size-padLarge );\n}\n.pane.pane-navBar {\n  padding-left: 12px;\n  border-bottom: 1px solid var( --color-base200 );\n  padding-right: 12px;\n  background-color: var( --color-base025 );\n}\n.pane.pane-attributeTableInlineEditor {\n  border: 1px solid transparent;\n  min-height: 32px;\n  border-radius: 4px;\n}\n.pane.pane-attributeTableInlineEditor:focus {\n  border-top-color: var( --color-base700 );\n  border-left-color: var( --color-base700 );\n  border-right-color: var( --color-base700 );\n  border-bottom-color: var( --color-base700 );\n}\n.pane.pane-navBarDivider {\n  margin-left: var( --size-padMedium );\n  background-color: var( --color-base200 );\n}\n.pane.pane-sideNavBarDivider {\n  height: 1px;\n  margin-top: 8px;\n  margin-bottom: 8px;\n  background-color: var( --color-base100 );\n}\n.pane.pane-dashboardGridCardEditorHeader {\n  padding: var( --size-padLarge );\n  background-color: var( --color-base100 );\n}\n.pane.pane-linearViewHeaderCell1 {\n  border-right: 1px solid var( --color-brand200 );\n  border-bottom: 1px solid var( --color-base100 );\n  background-color: var( --color-base025 );\n}\n.pane.pane-linearViewHeaderCell2 {\n  text-align: center;\n  border-right: 1px solid var( --color-base200 );\n  background-color: var( --color-base100 );\n}\n.pane.pane-linearViewBlock {\n  border: 1px solid var( --color-brand300 );\n  background-color: var( --color-brand100 );\n}\n.pane.pane-linearViewBlock:hover {\n  background-color: var( --color-brand200 );\n}\n.pane.pane-dialog.pane-linearViewBlockTooltip {\n  padding: var( --size-padMedium );\n  background-color: var( --color-white );\n}\n.pane.pane-linearViewRow {\n  border-bottom: 1px solid var( --color-base100 );\n}\n.pane.pane-pairContent {\n  background-color: var( --color-white );\n}\n.pane.pane-imageDetailValue {\n  width: 100px;\n  height: 100px;\n  background: url(\"data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==\") center center / cover;\n}\n.pane.pane-dashboardTransparentCardArea {\n  background-color: transparent;\n}\n.pane.pane-dashboardGridCardArea {\n  background-color: transparent;\n}\n.pane.pane-dialogTitle.pane-twoStepDialogTitle {\n  border-bottom-width: 0px;\n}\n.pane.pane-formBody.pane-twoStepContent {\n  width: auto;\n  max-width: 432px;\n  background-color: var( --color-white );\n}\n.pane.pane-twoStepMethodsCard {\n  border: 1px solid var( --color-base100 );\n  padding: var( --size-padXLarge ) var( --size-padLarge );\n  border-radius: 8px;\n  background-color: var( --color-white );\n}\n.pane.pane-screenContent.pane-securityScreenContent {\n  background-color: var( --color-base025 );\n}\n.pane.pane-formBody.pane-twoStepContent.pane-twoStepMobileContent {\n  width: 100%;\n}\n.pane.pane-dialog.pane-twoStep.pane-twoStepMobile {\n  min-height: 100%;\n}\n.pane.pane-rememberMeInfo {\n  width: 257px;\n  padding: var( --size-padMedium );\n}\n.pane.pane-loginPane.pane-expiredActivationToken {\n  width: 100%;\n  max-width: 360px;\n  padding-top: 24px;\n  padding-bottom: 24px;\n}\n.pane.pane-radio {\n  border: 1px solid var( --color-base100 );\n  padding: var( --size-padLarge );\n  border-radius: var( --size-padMedium );\n  background-color: var( --color-white );\n}\n.pane.pane-xyChartEditor {\n  height: 100%;\n  padding: var( --size-padLarge );\n  min-height: 600px;\n  margin-left: 0px;\n  margin-right: 0px;\n  background-color: var( --color-base050 );\n}\n.pane.pane-dashboardTransparentCardHeader {\n  padding: 0px;\n  border-top-color: transparent;\n  border-left-color: transparent;\n  border-right-color: transparent;\n  border-bottom-color: transparent;\n}\n.pane.pane-mobileOptBarDivider {\n  width: 100vw;\n  border: 1px solid var( --color-base100 );\n  transform: translate( -16px, 0 );\n  margin-top: 8px;\n  margin-right: -50%;\n  margin-bottom: 16px;\n}\n.pane.pane-mobileOptNavTitle {\n  height: 48px;\n  padding: 8px 16px;\n  border-bottom: 1px solid var( --color-base100 );\n}\n.pane.pane-mobileOptNav {\n  max-height: 90%;\n  padding-top: 2px;\n  padding-bottom: 2px;\n  background-color: var( --color-white );\n  border-top-left-radius: var( --size-medium );\n  border-top-right-radius: var( --size-medium );\n}\n.pane.pane-mobileNavTitle {\n  border-bottom: 1px solid var( --color-base100 );\n}\n.pane.pane-navSecondaryMobileTitle {\n  height: 48px;\n  border-bottom: 1px solid var( --color-base100 );\n}\n.pane.pane-mobileTopNavBarDivider {\n  margin: 16px -16px;\n  border-bottom: 1px solid var( --color-base100 );\n}\n.pane.pane-mobileFooterNav {\n  width: 100%;\n  border-top: 1px solid var( --color-base100 );\n  margin-top: auto;\n  padding-top: 4px;\n  padding-bottom: 4px;\n  background-color: var( --color-white );\n}\n.pane.pane-sortToggleBackground {\n  padding: var( --size-padSmall );\n  border-radius: var( --size-borderRadiusSmall );\n  background-color: #f3f5f6;\n}\n.pane.pane-maintenanceEvent {\n  width: 100%;\n  border: 2px solid var( --color-brand200 );\n  padding: var( --size-padLarge );\n  margin-top: var( --size-padMedium );\n  border-radius: 4px;\n  margin-bottom: var( --size-padMedium );\n  background-color: var( --color-white );\n}\n.pane.pane-maintenanceEvent.pane-maintenanceEventDegradation {\n  border-top-color: var( --color-warning500 );\n  border-left-color: var( --color-warning500 );\n  border-right-color: var( --color-warning500 );\n  border-bottom-color: var( --color-warning500 );\n}\n.pane.pane-maintenanceEvent.pane-maintenanceEventDowntime {\n  border-top-color: var( --color-danger500 );\n  border-left-color: var( --color-danger500 );\n  border-right-color: var( --color-danger500 );\n  border-bottom-color: var( --color-danger500 );\n}\n.pane.pane-infoCard {\n  border: 1px solid var( --color-base100 );\n  padding: var( --size-padMedium );\n  border-radius: var( --size-padSmall );\n  background-color: var( --color-brand025 );\n}\n.pane.pane-privacyNoticeContent {\n  max-height: 461px;\n}\n.pane.pane-dialog.pane-copyHoursWidget {\n  min-width: 240px;\n}\n.pane.pane-dialogBody.pane-largeDialogBody {\n  width: 80vw;\n  height: 80vh;\n}\n.pane.pane-formSearchBar {\n  padding: var( --size-padLarge );\n  border-bottom: 1px solid var( --color-base200 );\n  background-color: var( --color-base050 );\n}\n.pane.pane-formBreakdownItem {\n  border: 1px solid var( --color-base200 );\n  padding: var( --size-padMedium );\n  border-radius: var( --size-small );\n  background-color: var( --color-base025 );\n}\n.pane.pane-operatingHoursEditor {\n  padding: var( --size-padLarge );\n  background-color: var( --color-base025 );\n}\n.pane.pane-operatingHoursEditorContent {\n  border: 1px solid var( --color-base200 );\n  border-radius: 8px;\n  background-color: var( --color-white );\n}\n.pane.pane-operatingHoursWeeklyGrid {\n  border: 1px solid var( --color-base200 );\n  border-radius: var( --size-padMedium );\n}\n.pane.pane-copyHoursWidgetHeader {\n  padding: var( --size-padLarge );\n  border-bottom: 1px solid var( --color-base200 );\n}\n.pane.pane-copyHoursWidgetHeader.pane-copyHoursWidgetFooter {\n  border-bottom: none;\n}\n.pane.pane-detail {\n  box-shadow: 0 8px 16px var( --color-shadowBase ),0 0px 1px var( --color-shadowBase );\n  border-radius: 8px;\n  background-color: var( --color-white );\n}\n.pane.pane-theftRecoveryCardContent {\n  padding: var( --size-padLarge );\n}\n.pane.pane-dialogBody.pane-dialogFormBody {\n  background-color: var( --color-base050 );\n}\n.pane.pane-conditionEditor {\n  border: 0px solid var( --color-base100 );\n  padding: 16px;\n  max-height: auto;\n  border-radius: 2px;\n  background-color: transparent;\n}\n.pane.pane-preConditionBar {\n  width: 30px;\n  height: 30px;\n  margin-top: 4px;\n  margin-right: 4px;\n  border-radius: 2px;\n}\n.pane.pane-preConditionBar:hover {\n  background-color: var( --color-brand050 );\n}\n.pane.pane-conditionBar {\n  margin-top: 4px;\n  margin-left: 4px;\n}\n.pane.pane-simpleFilterEditor {\n  padding: 8px 16px 16px;\n  border-radius: 4px;\n  background-color: var( --color-base025 );\n}\n.pane.pane-simpleFilterEditorWrapper {\n  width: auto;\n  margin: 0px 1px 0px 0px;\n  padding: 8px;\n  min-width: 0px;\n  max-width: 320px;\n  border-top: 1px solid var( --color-base100 );\n}\n.pane.pane-pill {\n  font: normal 13px/20px Inter;\n  color: #495a6e;\n  border: 1px solid var( --color-base100 );\n  padding: var( --size-padSmall ) var( --size-padLarge );\n  margin-left: 0px;\n  margin-right: var( --size-padMedium );\n  border-radius: 100px;\n  background-color: var( --color-white );\n}\n.pane.pane-sortFilterBarHorizontalDivider {\n  height: 32px;\n  margin-top: 4px;\n  border-right: 1px solid var( --color-base200 );\n  margin-bottom: 4px;\n}\n.pane.pane-conditionsList {\n  border: 2px dotted var( --color-base400 );\n  padding: 4px;\n  text-align: left;\n  border-radius: 4px;\n  background-color: var( --color-base025 );\n}\n.pane.pane-conditionFilterEditor {\n  padding: 0px;\n}\n.pane.pane-dashboardGridCardEditor {\n  border: 1px solid var( --color-base400 );\n  border-radius: 4px;\n}\n.pane.pane-dialogContent.pane-questionBody {\n  padding: var( --size-padMedium );\n  background-color: var( --color-white );\n}\n.pane.pane-dashboardGridCardEditorAreaTarget {\n  background-color: var( --color-warning500 );\n}\n.pane.pane-dashboardPlaceholderCardTarget {\n  background-color: var( --color-brand200 );\n}\n.pane.pane-userEditorContent {\n  padding: var( --size-padLarge );\n}\n.pane.pane-userEditorHeader {\n  padding: var( --size-padMedium );\n}\n.pane.pane-dialogBodyAlt {\n  width: 496px;\n  padding: 16px;\n  background-color: var( --color-white );\n}\n.pane.pane-conditionRow {\n  padding: 8px 4px;\n  min-width: 480px;\n  transition: background-color var( --time-fast ) linear;\n  border-radius: 2px;\n}\n.pane.pane-conditionRow:hover {\n  border-radius: 8px;\n}\n.pane.pane-conditionRowEmpty {\n  height: 64px;\n  text-align: center;\n  padding-top: var( --size-padXLarge );\n  padding-bottom: var( --size-padXLarge );\n}\n.pane.pane-conditionRowEmpty:hover {\n  background: transparent;\n}\n.pane.pane-sortEditor {\n  padding: var( --size-padMedium ) var( --size-padLarge ) var( --size-padLarge );\n}\n.pane.pane-mobileNavBar {\n  width: 100%;\n  padding: 16px;\n}\n.pane.pane-disclaimerContainer {\n  padding: 8px 16px;\n  border-radius: 2px;\n  background-color: var( --color-base100 );\n}\n.pane.pane-noDataContent {\n  max-width: 400px;\n}\n.pane.pane-bulkCreateMapFieldsEntry {\n  padding-top: var( --size-padXLarge );\n}\n.pane.pane-ruleSetHeader {\n  padding: 0px var( --size-padLarge ) var( --size-padLarge );\n  border-bottom: 1px solid var( --color-base100 );\n  border-top-width: 1px;\n  border-top-color: var( --color-base100 );\n  border-left-width: 1px;\n  border-left-color: var( --color-base100 );\n  border-right-width: 1px;\n  border-right-color: var( --color-base100 );\n}\n.pane.pane-conditionEditor.pane-logicConditionEditor {\n  padding: var( --size-padMedium );\n  border-top-width: 0px;\n  border-top-color: var( --color-base200 );\n  border-left-width: 0px;\n  border-left-color: var( --color-base200 );\n  border-right-width: 0px;\n  border-right-color: var( --color-base200 );\n  border-bottom-width: 0px;\n  border-bottom-color: var( --color-base200 );\n}\n.pane.pane-ruleItem {\n  border: 1px solid var( --color-base100 );\n  padding: var( --size-padMedium );\n  min-width: 300px;\n  border-radius: var( --size-padMedium );\n}\n.pane.pane-ruleItem.pane-ruleBlock {\n  background-color: #e9eefc;\n  border-top-style: solid;\n  border-top-color: #1646c5;\n  border-left-style: solid;\n  border-left-color: #1646c5;\n  border-right-style: solid;\n  border-right-color: #1646c5;\n  border-bottom-style: solid;\n  border-bottom-color: #1646c5;\n}\n.pane.pane-ruleItem.pane-ruleBlock.pane-ruleBlockSelected {\n  border: 2px dashed #1646c5;\n  box-shadow: 0 3px 4px rgba( 0, 0, 0, 0.2 );\n  background-color: #a4b7ef;\n}\n.pane.pane-ruleItem.pane-logicRuleBlock {\n  background-color: #f9fafb;\n  border-top-width: 1px;\n  border-top-color: #67798e;\n  border-left-width: 1px;\n  border-left-color: #67798e;\n  border-right-width: 1px;\n  border-right-color: #67798e;\n  border-bottom-width: 1px;\n  border-bottom-color: #67798e;\n}\n.pane.pane-ruleItem.pane-ruleBlock.pane-ruleBlockSelected.pane-logicRuleBlockSelected {\n  background-color: #d0dae6;\n  border-top-color: #67798e;\n  border-left-color: #67798e;\n  border-right-color: #67798e;\n  border-bottom-color: #67798e;\n}\n.pane.pane-ruleItem.pane-modifyRuleBlock {\n  background-color: #fdf8f4;\n  border-top-width: 1px;\n  border-top-color: #c76e48;\n  border-left-width: 1px;\n  border-left-color: #c76e48;\n  border-right-width: 1px;\n  border-right-color: #c76e48;\n  border-bottom-width: 1px;\n  border-bottom-color: #c76e48;\n}\n.pane.pane-ruleItem.pane-ruleBlock.pane-ruleBlockSelected.pane-modifyRuleBlockSelected {\n  border: 2px dashed #c76e48;\n  box-shadow: 0 2px 4px rgba(183, 183, 183, 0.75);\n  background-color: #ffddd1;\n}\n.pane.pane-ruleItem.pane-sendRuleBlock {\n  background-color: #f4f9f7;\n  border-top-width: 1px;\n  border-top-color: #23a78d;\n  border-left-width: 1px;\n  border-left-color: #23a78d;\n  border-right-width: 1px;\n  border-right-color: #23a78d;\n  border-bottom-width: 1px;\n  border-bottom-color: #23a78d;\n}\n.pane.pane-ruleItem.pane-ruleBlock.pane-ruleBlockSelected.pane-sendRuleBlockSelected {\n  background-color: #afe2c7;\n  border-top-color: #23a78d;\n  border-left-color: #23a78d;\n  border-right-color: #23a78d;\n  border-bottom-color: #23a78d;\n}\n.pane.pane-ruleItem.pane-sendRuleBlock.pane-eventRuleBlock {\n  background-color: #f4f9f7;\n  border-top-width: 1px;\n  border-top-color: #23a78d;\n  border-left-width: 1px;\n  border-left-color: #23a78d;\n  border-right-width: 1px;\n  border-right-color: #23a78d;\n  border-bottom-width: 1px;\n  border-bottom-color: #23a78d;\n}\n.pane.pane-ruleItem.pane-ruleBlock.pane-ruleBlockSelected.pane-sendRuleBlockSelected.pane-eventRuleBlockSelected {\n  box-shadow: 0 0 4px rgba(183, 183, 183, 0.75);\n  background-color: #afe2c7;\n  border-top-color: #23a78d;\n  border-left-color: #23a78d;\n  border-right-color: #23a78d;\n  border-bottom-color: #23a78d;\n}\n.pane.pane-ruleItem.pane-debugRuleBlock {\n  background-color: #f6f6fa;\n  border-top-color: #382cdd;\n  border-left-color: #382cdd;\n  border-right-color: #382cdd;\n  border-bottom-color: #382cdd;\n}\n.pane.pane-ruleItem.pane-ruleBlock.pane-ruleBlockSelected.pane-debugRuleBlockSelected {\n  background-color: #bfb2ea;\n  border-top-color: #382cdd;\n  border-left-color: #382cdd;\n  border-right-color: #382cdd;\n  border-bottom-color: #382cdd;\n}\n.pane.pane-ruleBlockPropertySheet {\n  min-width: 500px;\n  box-shadow: -1px 0px 7px rgba(0, 0, 0, 0.05);\n  border-left: 1px solid var( --color-base100 );\n  background-color: var( --color-white );\n}\n.pane.pane-ruleBlockPropertySheetHeader {\n  padding: var( --size-padMedium );\n  border-bottom: 1px solid var( --color-base100 );\n  background-color: var( --color-white );\n}\n.pane.pane-footerItemBar {\n  margin-top: var( --size-padSmall );\n  margin-left: var( --size-padMedium );\n  margin-bottom: var( --size-padSmall );\n}\n.pane.pane-ruleItem.pane-ruleBlock.pane-computeRuleBlock {\n  background-color: #e9eefc;\n  border-top-width: 1px;\n  border-top-color: #1646c5;\n  border-left-width: 1px;\n  border-left-color: #1646c5;\n  border-right-width: 1px;\n  border-right-color: #1646c5;\n  border-bottom-width: 1px;\n  border-bottom-color: #1646c5;\n}\n.pane.pane-ruleItem.pane-ruleBlock.pane-ruleBlockSelected.pane-sendRuleBlockSelected.pane-computeRuleBlockSelected {\n  border: 2px dashed #1646c5;\n  background-color: #a4b7ef;\n}\n.pane.pane-templateEditor {\n  border: 1px solid var( --color-base025 );\n  margin: 0px;\n  text-align: left;\n  border-radius: var( --size-padSmall );\n  background-color: var( --color-base050 );\n}\n.pane.pane-templateTagEditor {\n  padding: var( --size-padLarge );\n}\n.pane.pane-detailGraphCard {\n  border-top-color: var( --color-base050 );\n  border-left-color: var( --color-base050 );\n  border-right-color: var( --color-base050 );\n  border-bottom-color: var( --color-base050 );\n}\n.pane.pane-aggregationCardItem {\n  padding: var( --size-padLarge );\n  border-top-width: 0px;\n  border-left-width: 0px;\n  border-right-width: 0px;\n  border-bottom-width: 0px;\n}\n.pane.pane-operatingHoursDayEven {\n  background-color: var( --color-base025 );\n}\n.pane.pane-operatingHoursDayOdd {\n  background-color: var( --color-white );\n}\n.pane.pane-detail.pane-detailCard.pane-detailBigCard {\n  padding-bottom: 16px;\n}\n.pane.pane-dashboardCardEditor.pane-dashboardCard.pane-dashboardSecondaryCard {\n  border-top-left-radius: var( --size-medium );\n  border-top-right-radius: var( --size-medium );\n  border-bottom-left-radius: 0px;\n  border-bottom-right-radius: 0px;\n}\n.pane.pane-dashboardCardEditor.pane-dashboardCard.pane-dashboardSectionCard {\n  border-top-left-radius: 0px;\n  border-top-right-radius: 0px;\n  border-bottom-left-radius: var( --size-medium );\n  border-bottom-right-radius: var( --size-medium );\n}\n.pane.pane-formBody.pane-twoStepContent.pane-twoStepRequiredContent {\n  width: auto;\n  max-height: 400px;\n  background-color: transparent;\n}\n.pane.pane-passwordRequirements {\n  padding: var( --size-padMedium ) 0px 8px;\n  border-radius: 4px;\n  background-color: transparent;\n}\n.pane.pane-releaseAvailableOverlay {\n  color: var( --color-brand700 );\n  border: 1px solid var( --color-brand700 );\n  padding: var( --size-padMedium );\n  border-radius: 4px;\n  background-color: var( --color-brand100 );\n}\n.pane.pane-topNavBreadcrumbs {\n  border-top: 0px solid var( --color-base200 );\n  background-color: var( --color-white );\n}\n.pane.pane-mainScreenHeader {\n  border-bottom: 1px solid var( --color-base200 );\n}\n.pane.pane-topNavBreadcrumbs.pane-mobileTopNavBreadcrumbs {\n  border-bottom: 1px solid var( --color-base200 );\n}\n.pane.pane-pairing {\n  border-radius: 4px;\n}\n.pane.pane-pairContent.pane-pairContentArea {\n  padding: var( --size-padLarge );\n  min-height: 350px;\n  background-color: var( --color-base050 );\n}\n.pane.pane-pairContent.pane-pairContentFooter {\n  padding: var( --size-padLarge );\n  background-color: var( --color-white );\n}\n.pane.pane-pairEditor {\n  width: 500px;\n  padding: var( --size-padLarge );\n  max-width: 100vw;\n  max-height: 100vh;\n  background-color: var( --color-base025 );\n}\n.pane.pane-deviceSelectorHeader {\n  padding: var( --size-padLarge ) var( --size-padLarge ) 0px;\n}\n.pane.pane-deviceSelectorContent {\n  padding: var( --size-padLarge );\n}\n.pane.pane-dialog.pane-attributeEditorDialog {\n  padding: var( --size-padMedium );\n}\n.pane.pane-editor.pane-imageEditor {\n  padding: 0px;\n  min-width: auto;\n  background-color: transparent;\n}\n.pane.pane-detail.pane-detailCard.pane-detailCardNoShadow {\n  width: 100%;\n  border: 1px solid var( --color-base200 );\n  box-shadow: none;\n}\n.pane.pane-array {\n  padding: 0px var( --size-padLarge );\n}\n.pane.pane-CustomTextEditor {\n  min-height: 100%;\n  background-color: var( --color-base025 );\n}\n.pane.pane-customTextEditorMenuActionBar {\n  padding: 8px 16px;\n  border-bottom: 1px solid var( --color-base200 );\n  background-color: var( --color-white );\n}\n.pane.pane-customTextValueEditor {\n  padding: var( --size-padMedium );\n}\n.pane.pane-customTextMenu {\n  padding: var( --size-padMedium );\n  border-bottom: 1px solid var( --color-base200 );\n  background-color: var( --color-white );\n  border-top-width: 0px;\n  border-left-width: 0px;\n  border-right-width: 0px;\n}\n.pane.pane-tempUserEditorBody {\n  padding: var( --size-padMedium );\n  background-color: var( --color-base050 );\n}\n.pane.pane-tempUserEditorHeader {\n  padding: var( --size-padMedium );\n  border-bottom: 1px solid var( --color-base100 );\n}\n.pane.pane-tempUserEditorFooter {\n  border-top: 1px solid var( --color-base100 );\n}\n.pane.pane-loginPane.pane-temporaryUserLoginPane {\n  padding-top: 80px;\n  padding-bottom: 80px;\n}\n.pane.pane-editorDialog.pane-tempUserEditorDialog {\n  width: 496px;\n}\n.pane.pane-shareTempUserBody {\n  padding: var( --size-padMedium );\n  border-top: 1px solid var( --color-base100 );\n  border-bottom: 1px solid var( --color-base100 );\n  background-color: var( --color-white );\n}\n.pane.pane-attributeTableGeoPointEditor {\n  width: 100%;\n  height: 100%;\n}\n.pane.pane-attributeTablePercentEditor {\n  width: 100%;\n}\n.pane.pane-array.pane-tableArray {\n  padding: 0px var( --size-padMedium );\n  margin-top: var( --size-padSmall );\n  margin-bottom: var( --size-padSmall );\n}\n.pane.pane-detailArray {\n  padding: var( --size-padMedium ) var( --size-padLarge );\n}\n.pane.pane-attributeCustomText {\n  padding-top: var( --size-padLarge );\n  padding-bottom: var( --size-padLarge );\n}\n.pane.pane-formLoadingView {\n  padding: var( --size-padMedium );\n}\n.pane.pane-detailImage {\n  padding-left: var( --size-padMedium );\n  padding-right: var( --size-padMedium );\n}\n.pane.pane-collectionEditorTreeSection {\n  width: 400px;\n}\n.pane.pane-tvCollectionView {\n  padding: var( --size-padLarge );\n  background-color: var( --color-white );\n}\n.pane.pane-card.pane-tvCollectionViewItem {\n  background-color: var( --color-brand050 );\n}\n.pane.pane-topNav.pane-mainNav {\n  height: 100%;\n  background-color: var( --color-mainNavPane );\n}\n.pane.pane-loginPane.pane-deviceCodeInfo {\n  box-shadow: none;\n}\n.pane.pane-loginPaneHalf {\n  width: 316px;\n  max-width: 80vw;\n}\n.pane.pane-deviceQRCode {\n  padding: var( --size-padMedium );\n  border-radius: 8px;\n  background-color: var( --color-brand025 );\n}\n.pane.pane-deviceQRCode.pane-deviceQRCodeError {\n  padding: var( --size-padLarge );\n  min-height: 200px;\n  background-color: var( --color-danger100 );\n}\n.pane.pane-imageListEditor {\n  width: 720px;\n  height: 720px;\n}\n.pane.pane-dialog.pane-ignoreAlertPreferences {\n  max-width: 30vw;\n}\n.pane.pane-dialog.pane-runInference {\n  max-width: auto;\n}\n.pane.pane-detail.pane-detailCard.pane-detailRsrcCard {\n  box-shadow: none;\n  border-radius: 0px;\n}\n.pane.pane-galleryItem {\n  border: 1px solid var( --color-base200 );\n  border-radius: 8px;\n}\n.pane.pane-galleryItem:hover {\n  border: 1px solid var( --color-brand500 );\n  box-shadow: 0 1px 3px var( --color-shadowBase );\n}\n.pane.pane-galleryItem:active {\n  border: 1px solid var( --color-brand900 );\n}\n.pane.pane-rsrcImageDetail {\n  width: 100dvw;\n  height: 100dvh;\n  background-color: #000000;\n}\n.pane.pane-rsrcImageDetailTitle {\n  padding: var( --size-padXLarge );\n  background: linear-gradient(0deg, rgba(0, 0, 0, 0), #000000 100%);\n}\n.pane.pane-rsrcEditorFooter {\n  padding: var( --size-padLarge ) var( --size-padMedium );\n}\n.pane.pane-rsrcEditorArea {\n  background-color: var( --color-base025 );\n}\n.pane.pane-rsrcEditor {\n  background-color: var( --color-white );\n}\n.pane.pane-listItem {\n  padding-left: var( --size-padMedium );\n  border-bottom: 1px solid var( --color-base050 );\n  padding-right: var( --size-padMedium );\n}\n.pane.pane-thumbnail {\n  box-shadow: 0 4px 8px rgba( 0, 0, 0, 0.2 );\n  border-radius: 8px;\n  background-color: var( --color-base025 );\n}\n.pane.pane-thumbnail:hover {\n  border: 1px solid var( --color-base200 );\n}\n.pane.pane-thumbnailTop {\n  border-bottom: 1px solid var( --color-base200 );\n}\n.pane.pane-thumbnailBottom {\n  padding: 8px;\n}\n.pane.pane-dialog.pane-dialogLarge {\n  width: 60%;\n}\n.pane.pane-dialog.pane-dialogLarge.pane-dialogMedium {\n  width: 40%;\n}\n.pane.pane-project {\n  width: 280px;\n  height: 160px;\n  padding: var( --size-padLarge );\n  box-shadow: 0 1px 3px var( --color-shadowBase );\n  margin-right: var( --size-padXLarge );\n  border-radius: var( --size-borderRadiusMedium );\n  margin-bottom: var( --size-padXLarge );\n  background-color: var( --color-white );\n}\n.pane.pane-project:hover {\n  box-shadow: 0 8px 16px var( --color-shadowBase ),0 0px 1px var( --color-shadowBase );\n}\n.pane.pane-project:active {\n  box-shadow: 0 0px 2px rgba( 0, 0, 0, 0.2 );\n  transition: all 0s;\n}\n.pane.pane-dialogContent.pane-projectDialogContent {\n  height: 100%;\n}\n.pane.pane-listEditorHeader {\n  padding: var( --size-padMedium );\n  border-right: 3px solid var( --color-base100 );\n  border-bottom: 3px solid var( --color-base100 );\n}\n.pane.pane-listEditorList {\n  border-right: 3px solid var( --color-base100 );\n  border-top-color: var( --color-base100 );\n  border-left-color: var( --color-base100 );\n  border-bottom-color: var( --color-base100 );\n}\n.pane.pane-listEditorList.pane-listEditorFooter {\n  padding: var( --size-padMedium );\n  border-top: 3px solid var( --color-base100 );\n  border-right: 3px solid var( --color-base100 );\n}\n.pane.pane-dialog.pane-attributeEditor {\n  border-radius: 0px;\n}\n.pane.pane-dialogHeader.pane-attributeEditorHeader {\n  color: #c51b67;\n  padding: var( --size-padMedium );\n  text-transform: uppercase;\n  background-color: var( --color-base100 );\n}\n.pane.pane-content {\n  background-color: var( --color-base100 );\n}\n.pane.pane-contentSidebar {\n  box-shadow: 0 1px 3px var( --color-shadowBase );\n  border-right: 1px solid var( --color-base100 );\n  background-color: var( --color-base025 );\n}\n.pane.pane-card.pane-enumCard {\n  padding: 0px;\n}\n.pane.pane-card.pane-enumCard:hover {\n  box-shadow: 0 4px 8px var( --color-brand050 );\n}\n.pane.pane-card.pane-enumCard:focus {\n  border-top-color: var( --color-base400 );\n  border-left-color: var( --color-base400 );\n  border-right-color: var( --color-base400 );\n  border-bottom-color: var( --color-base400 );\n}\n.pane.pane-profileContent {\n  padding: var( --size-padSmall );\n}\n.pane.pane-pill.pane-valueSourcePill {\n  background-color: var( --color-white );\n}\n.pane.pane-editor.pane-itemEditor {\n  height: 100%;\n  border-left: 1px solid var( --color-base200 );\n}\n.pane.pane-dialog.pane-ruleDialog {\n  min-width: 30vw;\n}\n.pane.pane-ruleItem.pane-sendRuleBlock.pane-commentRuleBlock {\n  max-width: 450px;\n  border-top-width: 2px;\n  border-left-width: 2px;\n  border-right-width: 2px;\n  border-bottom-width: 2px;\n}\n.pane.pane-ruleItem.pane-ruleBlock.pane-ruleBlockSelected.pane-sendRuleBlockSelected.pane-commentRuleBlockSelected {\n  max-width: 450px;\n}\n.pane-sortFilterBar {\n  height: 48px;\n  padding: 4px 16px;\n  min-height: auto;\n  border-bottom: 1px solid var( --color-base200 );\n  background-color: var( --color-base025 );\n}\n.pane-resourceImageValue {\n  padding: var( --size-padMedium );\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pane": `pane_ajaBp`,
	"pane-overlay": `pane-overlay_vxudj`,
	"pane-navHeader": `pane-navHeader_wiqfL`,
	"pane-loginPane": `pane-loginPane_kl1fh`,
	"pane-contentSection": `pane-contentSection_MJg2_`,
	"pane-contentBorder": `pane-contentBorder_e5jpf`,
	"pane-formHeader": `pane-formHeader_VXjDE`,
	"pane-formBody": `pane-formBody_o6CCf`,
	"pane-formButtons": `pane-formButtons_i_qgk`,
	"pane-dialogHeader": `pane-dialogHeader_kCcQX`,
	"pane-dialogBody": `pane-dialogBody_oizj4`,
	"pane-dialogFooter": `pane-dialogFooter_tP60i`,
	"pane-dialog": `pane-dialog_FXK8m`,
	"pane-loginWarning": `pane-loginWarning_zCQxl`,
	"pane-formGeoshape": `pane-formGeoshape_pnmYI`,
	"pane-contentSectionWhite": `pane-contentSectionWhite_djC5_`,
	"pane-card": `pane-card_kwSo4`,
	"pane-mobileTabPortal": `pane-mobileTabPortal_DwbOX`,
	"pane-mobileActions": `pane-mobileActions_k1Y4_`,
	"pane-mobileTabsHeader": `pane-mobileTabsHeader_rYSYY`,
	"pane-mobileList": `pane-mobileList_PBdHb`,
	"pane-mobileMapToggle": `pane-mobileMapToggle_pGDYP`,
	"pane-mobileItemHeader": `pane-mobileItemHeader_svJKE`,
	"pane-mobileItemBody": `pane-mobileItemBody_ePfFL`,
	"pane-mobileListSettings": `pane-mobileListSettings_RbkVN`,
	"pane-mobileDtrHeader": `pane-mobileDtrHeader_oFmAy`,
	"pane-mobileDtrContent": `pane-mobileDtrContent_ZPAWi`,
	"pane-sidebar": `pane-sidebar_Ipg9R`,
	"pane-tablePagination": `pane-tablePagination_eESLq`,
	"pane-editPageSizeOverlay": `pane-editPageSizeOverlay_y0Xjn`,
	"pane-rootHeader": `pane-rootHeader_bTPov`,
	"pane-dataCard": `pane-dataCard_kDUPJ`,
	"pane-graphContainer": `pane-graphContainer_Df06r`,
	"pane-detail": `pane-detail_ougWm`,
	"pane-detailCard": `pane-detailCard_iw3Dk`,
	"pane-detailHeader": `pane-detailHeader_jBddk`,
	"pane-detailContent": `pane-detailContent_bfmP9`,
	"pane-collectionEditorListSection": `pane-collectionEditorListSection_g6tci`,
	"pane-collectionEditorListHeader": `pane-collectionEditorListHeader_ApPnI`,
	"pane-collectionEditorSelectionSection": `pane-collectionEditorSelectionSection_hSxhF`,
	"pane-collectionEditorSelectionHeader": `pane-collectionEditorSelectionHeader_gciiA`,
	"pane-collectionEditorSelectionContent": `pane-collectionEditorSelectionContent_vMfBN`,
	"pane-dialogContent": `pane-dialogContent_B4P8x`,
	"pane-rootEditorContent": `pane-rootEditorContent_MeX7r`,
	"pane-editorDialog": `pane-editorDialog_g0A_m`,
	"pane-editor": `pane-editor_NYR8U`,
	"pane-formFooter": `pane-formFooter_ReEgG`,
	"pane-screenTitle": `pane-screenTitle_UjlsA`,
	"pane-topNav": `pane-topNav_UyBl5`,
	"pane-tableFilter": `pane-tableFilter_J9wCJ`,
	"pane-sideNav": `pane-sideNav_sHA6W`,
	"pane-screenContent": `pane-screenContent_OWAVf`,
	"pane-actionBar": `pane-actionBar_bHuF_`,
	"pane-aggregation": `pane-aggregation_qF9Ed`,
	"pane-dialogTitle": `pane-dialogTitle_zwz3L`,
	"pane-rootEditorHeader": `pane-rootEditorHeader_aC1yN`,
	"pane-rootEditorFooter": `pane-rootEditorFooter_Ob_UK`,
	"pane-listDetail": `pane-listDetail_vXDgW`,
	"pane-loginBackground": `pane-loginBackground_ykJDB`,
	"pane-mobileDetail": `pane-mobileDetail_jqByO`,
	"pane-cowList": `pane-cowList_k9GVx`,
	"pane-navSecondaryMobile": `pane-navSecondaryMobile_RKhI1`,
	"pane-mapActionBar": `pane-mapActionBar_H5gvl`,
	"pane-mobileMainNav": `pane-mobileMainNav_jc23E`,
	"pane-mobileNavRoutes": `pane-mobileNavRoutes_xZS9c`,
	"pane-mobileNavUser": `pane-mobileNavUser_Y_8bj`,
	"pane-dashboardCardEditor": `pane-dashboardCardEditor_Y4lV0`,
	"pane-dashboardCardEditorHeader": `pane-dashboardCardEditorHeader_hefe2`,
	"pane-dashboardCardEditorArea": `pane-dashboardCardEditorArea_NmL2F`,
	"pane-itemDashboard": `pane-itemDashboard_JVy71`,
	"pane-dashboardPlaceholderCard": `pane-dashboardPlaceholderCard_z8X4d`,
	"pane-dashboardPlaceholderCardHighlight": `pane-dashboardPlaceholderCardHighlight_vADXh`,
	"pane-dashboardNoData": `pane-dashboardNoData_UtquX`,
	"pane-dashboardCardHeader": `pane-dashboardCardHeader_odOyI`,
	"pane-dashboardCard": `pane-dashboardCard_fgmtj`,
	"pane-dashboardTransparentCard": `pane-dashboardTransparentCard_Tz_8p`,
	"pane-dashboardTransparentCardEditor": `pane-dashboardTransparentCardEditor_saeRB`,
	"pane-dashboardGridCard": `pane-dashboardGridCard_e0CX4`,
	"pane-dashboardCardEditorTarget": `pane-dashboardCardEditorTarget_X8C1T`,
	"pane-suggestions": `pane-suggestions_vuvdK`,
	"pane-itemForm": `pane-itemForm_xYDdb`,
	"pane-mobileItemForm": `pane-mobileItemForm_uFWiu`,
	"pane-mobileItemFormBody": `pane-mobileItemFormBody_qKEhT`,
	"pane-mobileItemFormHeader": `pane-mobileItemFormHeader_Zq3BZ`,
	"pane-navSecondaryMobileContainer": `pane-navSecondaryMobileContainer_zUyew`,
	"pane-mobileSearchHeader": `pane-mobileSearchHeader_LDhfH`,
	"pane-mobileMainHeader": `pane-mobileMainHeader_t7B97`,
	"pane-dashboardGridCardEditorArea": `pane-dashboardGridCardEditorArea_YxdY9`,
	"pane-itemDashboardContent": `pane-itemDashboardContent_BTx1G`,
	"pane-aggregationItem": `pane-aggregationItem_qsQwB`,
	"pane-mobileSimpleSearchArea": `pane-mobileSimpleSearchArea_oTWvE`,
	"pane-navBar": `pane-navBar_pLjVF`,
	"pane-attributeTableInlineEditor": `pane-attributeTableInlineEditor_Ru9Mv`,
	"pane-navBarDivider": `pane-navBarDivider_WXBux`,
	"pane-sideNavBarDivider": `pane-sideNavBarDivider_hno4o`,
	"pane-dashboardGridCardEditorHeader": `pane-dashboardGridCardEditorHeader_g20TJ`,
	"pane-linearViewHeaderCell1": `pane-linearViewHeaderCell1_nEmiJ`,
	"pane-linearViewHeaderCell2": `pane-linearViewHeaderCell2_KF29_`,
	"pane-linearViewBlock": `pane-linearViewBlock_rg8fJ`,
	"pane-linearViewBlockTooltip": `pane-linearViewBlockTooltip_PeZKY`,
	"pane-linearViewRow": `pane-linearViewRow_h4g9T`,
	"pane-pairContent": `pane-pairContent_hdFEw`,
	"pane-imageDetailValue": `pane-imageDetailValue_nLeEF`,
	"pane-dashboardTransparentCardArea": `pane-dashboardTransparentCardArea_Ztgwn`,
	"pane-dashboardGridCardArea": `pane-dashboardGridCardArea_cdrpz`,
	"pane-twoStepDialogTitle": `pane-twoStepDialogTitle_dPqQ6`,
	"pane-twoStepContent": `pane-twoStepContent_woEUd`,
	"pane-twoStepMethodsCard": `pane-twoStepMethodsCard__pAld`,
	"pane-securityScreenContent": `pane-securityScreenContent_X6sd6`,
	"pane-twoStepMobileContent": `pane-twoStepMobileContent_b9_xN`,
	"pane-twoStep": `pane-twoStep_ja_dF`,
	"pane-twoStepMobile": `pane-twoStepMobile_LxQhw`,
	"pane-rememberMeInfo": `pane-rememberMeInfo_qJpKQ`,
	"pane-expiredActivationToken": `pane-expiredActivationToken_f0rgQ`,
	"pane-radio": `pane-radio_yVdFs`,
	"pane-xyChartEditor": `pane-xyChartEditor_NUOoL`,
	"pane-dashboardTransparentCardHeader": `pane-dashboardTransparentCardHeader_J6JEl`,
	"pane-mobileOptBarDivider": `pane-mobileOptBarDivider_kFW1X`,
	"pane-mobileOptNavTitle": `pane-mobileOptNavTitle_zi4Xu`,
	"pane-mobileOptNav": `pane-mobileOptNav_c_VEZ`,
	"pane-mobileNavTitle": `pane-mobileNavTitle_B5b15`,
	"pane-navSecondaryMobileTitle": `pane-navSecondaryMobileTitle_R5yEq`,
	"pane-mobileTopNavBarDivider": `pane-mobileTopNavBarDivider_xA6Pk`,
	"pane-mobileFooterNav": `pane-mobileFooterNav_aHEEN`,
	"pane-sortToggleBackground": `pane-sortToggleBackground__iubB`,
	"pane-maintenanceEvent": `pane-maintenanceEvent_Hh1qc`,
	"pane-maintenanceEventDegradation": `pane-maintenanceEventDegradation_ADBII`,
	"pane-maintenanceEventDowntime": `pane-maintenanceEventDowntime_Kn2JJ`,
	"pane-infoCard": `pane-infoCard_JoYpf`,
	"pane-privacyNoticeContent": `pane-privacyNoticeContent_EEnta`,
	"pane-copyHoursWidget": `pane-copyHoursWidget_IJHpX`,
	"pane-largeDialogBody": `pane-largeDialogBody_IGANm`,
	"pane-formSearchBar": `pane-formSearchBar_mKDaN`,
	"pane-formBreakdownItem": `pane-formBreakdownItem_HFjVk`,
	"pane-operatingHoursEditor": `pane-operatingHoursEditor_jLOdu`,
	"pane-operatingHoursEditorContent": `pane-operatingHoursEditorContent_hpbCu`,
	"pane-operatingHoursWeeklyGrid": `pane-operatingHoursWeeklyGrid_IC3xk`,
	"pane-copyHoursWidgetHeader": `pane-copyHoursWidgetHeader__pbDz`,
	"pane-copyHoursWidgetFooter": `pane-copyHoursWidgetFooter_a3chO`,
	"pane-theftRecoveryCardContent": `pane-theftRecoveryCardContent_TzwzV`,
	"pane-dialogFormBody": `pane-dialogFormBody_x_94K`,
	"pane-conditionEditor": `pane-conditionEditor_juEFj`,
	"pane-preConditionBar": `pane-preConditionBar_bMCUz`,
	"pane-conditionBar": `pane-conditionBar_o1Ro0`,
	"pane-simpleFilterEditor": `pane-simpleFilterEditor_GdbyR`,
	"pane-simpleFilterEditorWrapper": `pane-simpleFilterEditorWrapper_jXdTG`,
	"pane-pill": `pane-pill_h_Rtd`,
	"pane-sortFilterBarHorizontalDivider": `pane-sortFilterBarHorizontalDivider_fxOvS`,
	"pane-conditionsList": `pane-conditionsList_5QeH1`,
	"pane-conditionFilterEditor": `pane-conditionFilterEditor_sXZan`,
	"pane-dashboardGridCardEditor": `pane-dashboardGridCardEditor_PNPYx`,
	"pane-questionBody": `pane-questionBody_jF8kU`,
	"pane-dashboardGridCardEditorAreaTarget": `pane-dashboardGridCardEditorAreaTarget_u4Q1F`,
	"pane-dashboardPlaceholderCardTarget": `pane-dashboardPlaceholderCardTarget_hmYUV`,
	"pane-userEditorContent": `pane-userEditorContent_OlpZk`,
	"pane-userEditorHeader": `pane-userEditorHeader_sB40n`,
	"pane-dialogBodyAlt": `pane-dialogBodyAlt_V7c6g`,
	"pane-conditionRow": `pane-conditionRow_nxVi4`,
	"pane-conditionRowEmpty": `pane-conditionRowEmpty_H8T7A`,
	"pane-sortEditor": `pane-sortEditor_mYlAT`,
	"pane-mobileNavBar": `pane-mobileNavBar_jtJ0y`,
	"pane-disclaimerContainer": `pane-disclaimerContainer_EGcv9`,
	"pane-noDataContent": `pane-noDataContent_VRfa6`,
	"pane-bulkCreateMapFieldsEntry": `pane-bulkCreateMapFieldsEntry_recKx`,
	"pane-ruleSetHeader": `pane-ruleSetHeader_f7afX`,
	"pane-logicConditionEditor": `pane-logicConditionEditor_Fm0h_`,
	"pane-ruleItem": `pane-ruleItem_b6H05`,
	"pane-ruleBlock": `pane-ruleBlock_DyThC`,
	"pane-ruleBlockSelected": `pane-ruleBlockSelected_UbRnq`,
	"pane-logicRuleBlock": `pane-logicRuleBlock_ZgwHc`,
	"pane-logicRuleBlockSelected": `pane-logicRuleBlockSelected_B8wHy`,
	"pane-modifyRuleBlock": `pane-modifyRuleBlock_VDIfL`,
	"pane-modifyRuleBlockSelected": `pane-modifyRuleBlockSelected_j0NVA`,
	"pane-sendRuleBlock": `pane-sendRuleBlock_rpkSa`,
	"pane-sendRuleBlockSelected": `pane-sendRuleBlockSelected_V0qHd`,
	"pane-eventRuleBlock": `pane-eventRuleBlock_haVLg`,
	"pane-eventRuleBlockSelected": `pane-eventRuleBlockSelected_TR5rE`,
	"pane-debugRuleBlock": `pane-debugRuleBlock_uroXZ`,
	"pane-debugRuleBlockSelected": `pane-debugRuleBlockSelected_cTUMu`,
	"pane-ruleBlockPropertySheet": `pane-ruleBlockPropertySheet_GjIOT`,
	"pane-ruleBlockPropertySheetHeader": `pane-ruleBlockPropertySheetHeader_gfNrW`,
	"pane-footerItemBar": `pane-footerItemBar_qEuGE`,
	"pane-computeRuleBlock": `pane-computeRuleBlock_t7bSU`,
	"pane-computeRuleBlockSelected": `pane-computeRuleBlockSelected_W39y0`,
	"pane-templateEditor": `pane-templateEditor_fHkJk`,
	"pane-templateTagEditor": `pane-templateTagEditor_j1sjD`,
	"pane-detailGraphCard": `pane-detailGraphCard_l9FSd`,
	"pane-aggregationCardItem": `pane-aggregationCardItem_atENr`,
	"pane-operatingHoursDayEven": `pane-operatingHoursDayEven_FmNrq`,
	"pane-operatingHoursDayOdd": `pane-operatingHoursDayOdd_t8FhX`,
	"pane-detailBigCard": `pane-detailBigCard_STB4q`,
	"pane-dashboardSecondaryCard": `pane-dashboardSecondaryCard__28N8`,
	"pane-dashboardSectionCard": `pane-dashboardSectionCard_j4Aep`,
	"pane-twoStepRequiredContent": `pane-twoStepRequiredContent_OEQjQ`,
	"pane-passwordRequirements": `pane-passwordRequirements_Zp2g8`,
	"pane-releaseAvailableOverlay": `pane-releaseAvailableOverlay_x0sDX`,
	"pane-topNavBreadcrumbs": `pane-topNavBreadcrumbs_FJXpN`,
	"pane-mainScreenHeader": `pane-mainScreenHeader_qmeRi`,
	"pane-mobileTopNavBreadcrumbs": `pane-mobileTopNavBreadcrumbs_uFMhf`,
	"pane-pairing": `pane-pairing_LtNBe`,
	"pane-pairContentArea": `pane-pairContentArea_PVlPO`,
	"pane-pairContentFooter": `pane-pairContentFooter_LOiml`,
	"pane-pairEditor": `pane-pairEditor_QIvz2`,
	"pane-deviceSelectorHeader": `pane-deviceSelectorHeader_NumSx`,
	"pane-deviceSelectorContent": `pane-deviceSelectorContent_WxPns`,
	"pane-attributeEditorDialog": `pane-attributeEditorDialog_mfhyW`,
	"pane-imageEditor": `pane-imageEditor_Kg7F2`,
	"pane-detailCardNoShadow": `pane-detailCardNoShadow_hoB5M`,
	"pane-array": `pane-array_v3vXr`,
	"pane-CustomTextEditor": `pane-CustomTextEditor_KmYw_`,
	"pane-customTextEditorMenuActionBar": `pane-customTextEditorMenuActionBar_U1YhJ`,
	"pane-customTextValueEditor": `pane-customTextValueEditor_iu8i2`,
	"pane-customTextMenu": `pane-customTextMenu_qg0s3`,
	"pane-tempUserEditorBody": `pane-tempUserEditorBody_ow7kv`,
	"pane-tempUserEditorHeader": `pane-tempUserEditorHeader_yyDVu`,
	"pane-tempUserEditorFooter": `pane-tempUserEditorFooter_h5EDg`,
	"pane-temporaryUserLoginPane": `pane-temporaryUserLoginPane_gJp9A`,
	"pane-tempUserEditorDialog": `pane-tempUserEditorDialog_zJeRA`,
	"pane-shareTempUserBody": `pane-shareTempUserBody_NwCnY`,
	"pane-attributeTableGeoPointEditor": `pane-attributeTableGeoPointEditor_M4cMb`,
	"pane-attributeTablePercentEditor": `pane-attributeTablePercentEditor_AH_iW`,
	"pane-tableArray": `pane-tableArray_kuT3y`,
	"pane-detailArray": `pane-detailArray_djvWq`,
	"pane-attributeCustomText": `pane-attributeCustomText_QRKLq`,
	"pane-formLoadingView": `pane-formLoadingView_uTVM7`,
	"pane-detailImage": `pane-detailImage_ppVWP`,
	"pane-collectionEditorTreeSection": `pane-collectionEditorTreeSection_ri9D5`,
	"pane-tvCollectionView": `pane-tvCollectionView_V2qj9`,
	"pane-tvCollectionViewItem": `pane-tvCollectionViewItem_mTK8u`,
	"pane-mainNav": `pane-mainNav_HOfZF`,
	"pane-deviceCodeInfo": `pane-deviceCodeInfo_gp2I3`,
	"pane-loginPaneHalf": `pane-loginPaneHalf_e1L9X`,
	"pane-deviceQRCode": `pane-deviceQRCode_VqLTD`,
	"pane-deviceQRCodeError": `pane-deviceQRCodeError_G89hn`,
	"pane-imageListEditor": `pane-imageListEditor_kwPct`,
	"pane-ignoreAlertPreferences": `pane-ignoreAlertPreferences_pgKzV`,
	"pane-runInference": `pane-runInference_NlHIn`,
	"pane-detailRsrcCard": `pane-detailRsrcCard_KR2UE`,
	"pane-galleryItem": `pane-galleryItem_IOJhU`,
	"pane-rsrcImageDetail": `pane-rsrcImageDetail_AkgcF`,
	"pane-rsrcImageDetailTitle": `pane-rsrcImageDetailTitle_yVeFu`,
	"pane-rsrcEditorFooter": `pane-rsrcEditorFooter_xmzEO`,
	"pane-rsrcEditorArea": `pane-rsrcEditorArea_KrNmW`,
	"pane-rsrcEditor": `pane-rsrcEditor_ZGDx3`,
	"pane-listItem": `pane-listItem_IAl3k`,
	"pane-thumbnail": `pane-thumbnail_a9qYa`,
	"pane-thumbnailTop": `pane-thumbnailTop_wuLEw`,
	"pane-thumbnailBottom": `pane-thumbnailBottom_KWGHy`,
	"pane-dialogLarge": `pane-dialogLarge_Gbb0B`,
	"pane-dialogMedium": `pane-dialogMedium_DrTCJ`,
	"pane-project": `pane-project_jnpOy`,
	"pane-projectDialogContent": `pane-projectDialogContent_kVaiw`,
	"pane-listEditorHeader": `pane-listEditorHeader__xYdQ`,
	"pane-listEditorList": `pane-listEditorList_MvD9P`,
	"pane-listEditorFooter": `pane-listEditorFooter_cE5pi`,
	"pane-attributeEditor": `pane-attributeEditor_tOd_1`,
	"pane-attributeEditorHeader": `pane-attributeEditorHeader_rHHjh`,
	"pane-content": `pane-content_pK4zZ`,
	"pane-contentSidebar": `pane-contentSidebar_hK1xq`,
	"pane-enumCard": `pane-enumCard_l4WCU`,
	"pane-profileContent": `pane-profileContent_DGud1`,
	"pane-valueSourcePill": `pane-valueSourcePill_tEDU_`,
	"pane-itemEditor": `pane-itemEditor_TJTpw`,
	"pane-ruleDialog": `pane-ruleDialog_tfwgN`,
	"pane-commentRuleBlock": `pane-commentRuleBlock_C56Ko`,
	"pane-commentRuleBlockSelected": `pane-commentRuleBlockSelected_Q9Mqz`,
	"pane-sortFilterBar": `pane-sortFilterBar_GUjSt`,
	"pane-resourceImageValue": `pane-resourceImageValue_Jyz81`
};
export default ___CSS_LOADER_EXPORT___;
